import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import _, { set } from 'lodash';
import {
  Card,
  Row,
  Col,
  DatePicker,
  Select,
  Space,
  Statistic,
  Layout,
  Button,
  Dropdown,
  Spin,
  message,
  Table,
  Tabs,
  Tooltip,
  Badge,
  Modal
} from 'antd';

import styles from "./index.module.css";
import { fetchAllTransportOrganizations, fetchTCDrivers, resetDrivers } from '../../../store/transport_organizations';
import { fetchAllHealthOrganizations } from '../../../store/health_organizations';
import { getReportingRides } from '../../../store/rides';

import {
  DownloadOutlined,
  ReloadOutlined,

  FileExcelOutlined,

  CarOutlined,
  UserOutlined,

  FilterOutlined,
  TeamOutlined,

  WarningOutlined,
  StarFilled,
  StarOutlined
} from '@ant-design/icons';
import { RidesCompletedIcon, RideCancelledIcon, TotalMemberedServeIcon, UniqueMemberServedIcon, RiderNoShowIcon, MedhaulInsightsIcon, FiltersIcon, OverviewIcon, AccessIcon, DetailedViewIcon, GeoInsightsIcon, CancellationIcon, ReportsIcon, ReportingIcon, InfoIcon, MemberSatisfactionIcon, TcPerformanceIcon } from '../../../assets';
import * as d3 from 'd3';

import * as XLSX from 'xlsx';

import dayjs from 'dayjs';

import customParseFormat from 'dayjs/plugin/customParseFormat';
import { fetchRidesData, generateMockRides } from '../../../components/charts/mockRides/mockRides';
import classNames from 'classnames';
import { ReportsSection } from '../../../components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { RIDE_STATUSES, USER_ROLES, VEHICLE_TYPES_LABEL, EXPORT_MESSAGES } from '../../../constants/constants';
import { exportReport } from '../../../store/reports';
import RideRating from '../../../components/common/RideRating/RideRating';
import { useSelector } from 'react-redux';


dayjs.extend(customParseFormat);

// Custom D3 Charts
const StatusPieChart = React.lazy(() => import('../../../components/charts/StatusPieChart/StatusPieChart'));
const RidesByCountyChart = React.lazy(() => import('../../../components/charts/RidesByCountyChart/RidesByCountyChart'));
const MonthlyTrendChart = React.lazy(() => import('../../../components/charts/MonthlyTrendChart/MonthlyTrendChart'));
const DonutChartWithCenterTotal = React.lazy(() => import('../../../components/charts/donutChartWithCenterTotal/donutChartWithCenterTotal'));
const BarChart = React.lazy(() => import('../../../components/charts/barChart/barchart'));

const { Header, Content } = Layout;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { TabPane } = Tabs;

const statusColors = {
  PENDING: '#faad14',
  ACCEPTED: '#1890ff',
  START: '#13c2c2',
  COMPLETED: '#52c41a',
  EXPIRED: '#f5222d',
  CANCELED: '#eb2f96',
  UNFULFILLED: '#722ed1',
  UNABLE_TO_FULFILL: '#722ed1'

};


const statusLabel = {
  PENDING: 'Pending',
  ACCEPTED: 'Accepted',
  START: 'Start',
  COMPLETED: 'Completed',
  EXPIRED: 'Expired',
  CANCELED: 'Canceled',
  UNFULFILLED: 'Unable to Fulfill',
  UNABLE_TO_FULFILL: 'Unable to Fulfill',
  IN_PROGRESS: 'In Progress',

};


const vehicleTypesColors = {
  ambulatoryRiderIsWalking: 'red',
  ambulatoryAssistRiderIsWalking: 'green',

  CANCELED: '#eb2f96',
  UNFULFILLED: '#722ed1'
};

const MH_Reporting_Dashboard = ({

  fetchAllTransportOrganizations,
  getReportingRides,
  fetchTCDrivers,
  resetDrivers,
  fetchAllHealthOrganizations,
  transportCompanies,
  drivers,
  ridesData,
  summary,
  exportReport,
  loading,
  healthOrganizations }

) => {

  const [dateRange, setDateRange] = useState([dayjs().subtract(1, 'month'), dayjs()]);
  const [selectedOrg, setSelectedOrg] = useState('all');
  const [selectedTransport, setSelectedTransport] = useState('all');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [selectedVehicleType, setSelectedVehicleType] = useState('all');
  const [selectedDriver, setSelectedDriver] = useState('all');
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [activeTab, setActiveTab] = useState('1');
  const [showFilters, setShowFilters] = useState(true);
  const [selectedRide, setSelectedRide] = useState(null);
  const [rideModalVisible, setRideModalVisible] = useState(false);

  const userInfo = useSelector((state) => state.authorization?.user);
  const userRole = useSelector((state) => state.authorization?.user?.role)
  const viewComponents = useSelector((state) => state.authorization?.user?.organization ?
    state.authorization?.user?.organization?.addons?.insightsEnabled : state.authorization?.user?.orgAddons?.insightsEnabled);
  const disabledDate = (current) => {
    if (!dateRange || dateRange.length === 0) {
      return false;
    }
    const [start, end] = dateRange;

    // Always allow selecting a new start date
    if (!start || !end) {
      return false;
    }

    // When both dates are selected, restrict only the end date to 90 days from start
    return (
      current && (current.isBefore(start, 'day') || current.isAfter(start.add(90, 'day'), 'day'))
    );
  };

  function stringToColor(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      color += ('00' + ((hash >> (i * 8)) & 0xFF).toString(16)).slice(-2);
    }
    return color;
  }

  const rideDistanceCategories = [
    { key: 'urban', label: 'Urban (≤ 50 miles)' },
    { key: 'subUrban', label: 'Suburban (51-75 miles)' },
    { key: 'rural', label: 'Rural (> 75 miles)' },
  ];

  const rideReschduleCancellation = [
    { key: 'RESCHEDULED', label: 'Rescheduled Rides' },
    { key: 'CANCELED', label: 'Canceled' },
    { key: 'RESCHEDULED_CANCELED', label: 'Reschedule & Canceled' },
  ];

  const TcStatus = [
    { key: 'COMPLETED', label: 'Completed' },
    { key: 'OTHER', label: 'Other' },

  ];

  const rideStatuses = [
    { key: 'rides', label: 'All Rides', color: statusColors.ACCEPTED },
    { key: 'COMPLETED', label: 'Completed', color: statusColors.COMPLETED },
    { key: 'PENDING', label: 'Pending', color: statusColors.PENDING },
    { key: 'EXPIRED', label: 'Expired', color: statusColors.EXPIRED },

    { key: 'UNABLE_TO_FULFILL', label: 'Unable to Fulfill', color: statusColors.UNFULFILLED },

  ]
  // Star rating component
  const renderStarRating = (score) => {
    const fullStars = Math.floor(score);
    const hasHalfStar = score % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return (
      <div>
        {[...Array(fullStars)].map((_, i) => (
          <StarFilled key={`full-${i}`} style={{ color: '#ffc53d', fontSize: 20 }} />
        ))}
        {hasHalfStar && (
          <StarFilled key="half" style={{ color: '#ffc53d', fontSize: 20, opacity: 0.5 }} />
        )}
        {[...Array(emptyStars)].map((_, i) => (
          <StarOutlined key={`empty-${i}`} style={{ color: '#ffc53d', fontSize: 20 }} />
        ))}
      </div>
    );
  };


  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (viewComponents && userRole === USER_ROLES.HO_ADMIN) {
      setSelectedOrg(userInfo?.organizationId);
    }
  }, [viewComponents, userRole, userInfo?.organizationId]);

  useEffect(() => {
    if (userRole === USER_ROLES.SUPER_ADMIN) {
      fetchAllTransportOrganizations();
      fetchAllHealthOrganizations();
    }

    if (userRole === USER_ROLES.ENTERPRISE_ADMIN) {
      fetchAllHealthOrganizations();
    }

    return () => { };
  }, [fetchAllTransportOrganizations, fetchAllHealthOrganizations]);


  useEffect(() => {
    if (selectedTransport && selectedTransport !== 'all') {
      // Call fetchTCDrivers when a valid transport company is selected
      fetchTCDrivers(selectedTransport);
    } else {
      // Reset drivers if no transport company is selected
      resetDrivers();
    }

    // Reset the selected driver to 'all' whenever the transport company changes
    setSelectedDriver('all');
  }, [selectedTransport, fetchTCDrivers, resetDrivers]);

  // Fetch reference data (orgs, transport companies, drivers)
  const fetchReferenceData = useCallback(async () => {
    try {
      // In a real app, these would be API calls


      // const mockDrivers = [
      //   { id: 'driver1', name: 'John Smith' },
      //   { id: 'driver2', name: 'Maria Garcia' },
      //   { id: 'driver3', name: 'David Johnson' }
      // ];


      // setDrivers(mockDrivers);
    } catch (error) {
      message.error('Failed to load reference data');
      console.error('Error loading reference data:', error);
    }
  }, []);

  // Fetch rides data from API
  const fetchData = useCallback(async () => {

    try {
      if (!dateRange || dateRange.length !== 2) {
        return;
      }

      const data = await getReportingRides({
        startDate: dateRange[0].format('YYYY-MM-DD'),
        endDate: dateRange[1].format('YYYY-MM-DD'),
        healthOrganizationId: selectedOrg !== 'all' ? selectedOrg : undefined,
        transportCompanyId: selectedTransport !== 'all' ? selectedTransport : undefined,
        status: selectedStatus !== 'all' ? selectedStatus : undefined,
        vehicleType: selectedVehicleType !== 'all' ? selectedVehicleType : undefined,
        driverId: selectedDriver !== 'all' ? selectedDriver : undefined
      });


    } catch (error) {
      message.error('Failed to fetch ride data');
      console.error('Error fetching ride data:', error);
    } finally {

    }
  }, [dateRange, selectedOrg, selectedTransport, selectedStatus, selectedVehicleType, selectedDriver]);

  // Initial data load
  useEffect(() => {
    fetchReferenceData();
    fetchData();
  }, [fetchReferenceData, fetchData]);

  // Processed data for charts
  const processedData = useMemo(() => {
    if (!ridesData || ridesData?.length === 0) {
      return {
        statusCounts: {},
        monthlyTrends: [],
        orgPerformance: [],
        transportPerformance: [],
        driverPerformance: [],
        vehicleTypeCounts: {},
        counties: [],
        hoActivityCounts: {},
        cancellationData: {},
        monthlyPatientTrends: [],
        recurrenceAnalysis: {},
        timeMetrics: {
          avgResponseTime: 'N/A',
          avgLoadTime: 'N/A',
          avgRideDuration: 'N/A',
          avgWaitTime: 'N/A',
          avgMileage: 'N/A'
        },
        rawData: []
      };
    }


    // Status distribution
    const statusCounts = ridesData.reduce((acc, ride) => {
      acc[ride.status] = (acc[ride.status] || 0) + 1;

      return acc;
    }, {});


    // Vehicle type distribution
    const vehicleTypeCounts = ridesData.reduce((acc, ride) => {
      const type = ride.vehicleType || 'Unknown';
      acc[type] = (acc[type] || 0) + 1;
      return acc;
    }, {});

    // Cost Center distribution
    const costCenterCounts = ridesData.reduce((acc, ride) => {
      let costCenter = ride.costCenter ? ride.costCenter.trim() : '';

      // If cost center is empty or not assigned, use organization name
      if (!costCenter) {
        const org = healthOrganizations.find(o => o.id === ride.healthOrganizationId);
        costCenter = org ? org.name : 'Not Assigned';
      }

      acc[costCenter] = (acc[costCenter] || 0) + 1;
      return acc;
    }, {});

    // Extract county from pickup address (assuming format like "123 Main St, King County")
    const countyData = ridesData.reduce((acc, ride) => {
      const countyMatch = ride.pickupAddressDetails.county;
      const county = countyMatch ? countyMatch.trim() : 'Unknown';
      acc[county] = (acc[county] || 0) + 1;
      return acc;
    }, {});

    const counties = Object.entries(countyData)
      .map(([county, count]) => ({ county, count }))
      .sort((a, b) => b.count - a.count);


    const hoActivityCounts = getHOActivityCount(ridesData, 'createdBy');



    // Monthly trends
    const monthlyTrends = ridesData.reduce((acc, ride) => {
      const month = dayjs(ride.pickUpDate).format('MMM YYYY');
      if (!acc[month]) {
        acc[month] = {
          month,
          rides: 0,
          COMPLETED: 0,
          PENDING: 0,
          EXPIRED: 0,
          UNABLE_TO_FULFILL: 0,
          RESCHEDULED: 0,
          CANCELED: 0,
          RESCHEDULED_CANCELED: 0,

        };
      }
      acc[month].rides++;

      if (ride.isRescheduled === true) acc[month].RESCHEDULED++;
      if (ride.isRescheduled === true && ride.status === RIDE_STATUSES.CANCELED) acc[month].RESCHEDULED_CANCELED++;
      if (ride.status === RIDE_STATUSES.CANCELED) acc[month].CANCELED++;
      if (ride.status === RIDE_STATUSES.COMPLETED) acc[month].COMPLETED++;
      if (ride.status === RIDE_STATUSES.PENDING) acc[month].PENDING++;
      if (ride.status === RIDE_STATUSES.EXPIRED) acc[month].EXPIRED++;
      if (ride.status === RIDE_STATUSES.UNABLE_TO_FULFILL) acc[month].UNABLE_TO_FULFILL++;


      return acc;
    }, {});



    // Organization performance
    const orgPerformance = ridesData.reduce((acc, ride) => {
      const orgId = ride.healthOrganizationId;
      const orgName = healthOrganizations.find(o => o.id === orgId)?.name || `Org ${orgId}`;

      if (!acc[orgId]) {
        acc[orgId] = {
          org: orgName,
          COMPLETED: 0,
          FAILED: 0,
          PENDING: 0,
          EXPIRED: 0,
          CANCELED: 0,
          UNABLE_TO_FULFILL: 0
        };
      }
      if (ride.status === RIDE_STATUSES.COMPLETED) acc[orgId].COMPLETED++;
      if (ride.status === RIDE_STATUSES.CANCELED) acc[orgId].CANCELED++;
      if (ride.status === RIDE_STATUSES.EXPIRED) acc[orgId].EXPIRED++;
      if (ride.status === RIDE_STATUSES.UNFULFILLED) acc[orgId].UNABLE_TO_FULFILL++;
      if (ride.status === RIDE_STATUSES.PENDING) acc[orgId].PENDING++;
      return acc;
    }, {});

    // Transport company performance
    const transportPerformance = ridesData.reduce((acc, ride) => {
      const tcId = ride.transportCompanyId;
      const tcName = transportCompanies.find(t => t.id === tcId)?.name || `Co. ${tcId}`;

      if (!acc[tcId]) {
        acc[tcId] = {
          company: tcName,
          COMPLETED: 0,
          OTHER: 0,
          PENDING: 0,
          avgResponseTime: 0,
          responseTimeCount: 0
        };
      }
      if (ride.status === RIDE_STATUSES.COMPLETED) acc[tcId].COMPLETED++;
      if ([RIDE_STATUSES.EXPIRED, RIDE_STATUSES.UNABLE_TO_FULFILL].includes(ride.status)) acc[tcId].OTHER++;
      if (ride.status === RIDE_STATUSES.PENDING) acc[tcId].PENDING++;

      // Calculate response time metrics
      if (ride.acceptanceTime && ride.createdAt) {
        const responseMs = new Date(ride.acceptanceTime) - new Date(ride.createdAt);
        acc[tcId].avgResponseTime += responseMs;
        acc[tcId].responseTimeCount++;
      }
      return acc;
    }, {});

    // Calculate average response times
    Object.values(transportPerformance).forEach(tc => {
      if (tc.responseTimeCount > 0) {
        tc.avgResponseTime = formatDuration(tc.avgResponseTime / tc.responseTimeCount);
      } else {
        tc.avgResponseTime = 'N/A';
      }
    });

    // Driver performance
    const driverPerformance = ridesData.reduce((acc, ride) => {
      if (!ride.driverId) return acc;

      const driverId = ride.driverId;
      // console.log('Driver ID:', driverId);
      // console.log('Driver Name:', drivers);
      // const driverName = drivers.find(d => d.id === driverId)?.name || `Driver ${driverId}`;

      if (!acc[driverId]) {
        acc[driverId] = {
          driver: ride.driverName,
          COMPLETED: 0,
          FAILED: 0,
          avgRating: 0,
          ratingCount: 0,
          totalMiles: 0
        };
      }
      if (ride.status === RIDE_STATUSES.COMPLETED) acc[driverId].COMPLETED++;
      if ([RIDE_STATUSES.EXPIRED, RIDE_STATUSES.UNABLE_TO_FULFILL].includes(ride.status)) acc[driverId].failed++;

      // Calculate driver metrics (assuming we have rating and mileage data)
      if (ride.driverRating) {
        acc[driverId].avgRating += ride.driverRating;
        acc[driverId].ratingCount++;
      }
      if (ride.actMileage) {
        acc[driverId].totalMiles += parseFloat(ride.actMileage) || 0;
      }
      return acc;
    }, {});

    // Calculate average ratings
    Object.values(driverPerformance).forEach(driver => {
      if (driver.ratingCount > 0) {
        driver.avgRating = (driver.avgRating / driver.ratingCount).toFixed(1);
      } else {
        driver.avgRating = 'N/A';
      }
    });



    // Recurrence analysis
    const recurrenceAnalysis = ridesData.reduce((acc, ride) => {
      const key = ride.isRecurring ? 'Recurring' : 'One-time';
      acc[key] = (acc[key] || 0) + 1;
      return acc;
    }, {});

    // Time metrics
    const timeMetrics = {
      avgResponseTime: calculateAverageTime(ridesData, 'acceptanceTime', 'createdAt'),
      avgLoadTime: calculateAverageTime(ridesData, 'loadTime', 'acceptanceTime'),
      avgRideDuration: calculateAverageTime(ridesData, 'unloadTime', 'loadTime'),
      avgWaitTime: calculateAverageWaitTime(ridesData),
      avgMileage: calculateAverageMileage(ridesData)
    };

    const monthlyTrendsData = Object.values(monthlyTrends).sort((a, b) =>
      dayjs(a.month, 'MMM YYYY').diff(dayjs(b.month, 'MMM YYYY')))




    // Calculate no-shows (assuming status indicates no-shows)
    const noShowsCount = summary?.noShowCancellations?.count;
    const noShowRatio = summary?.noShowCancellations?.ratio || 0;
    // Calculate satisfaction (mock data - replace with actual)
    const satisfactionScore = summary?.satisfactionScore || 0; // Average from your data
    const satisfactionResponses = summary?.satisfactionResponses || 0; // Total ratings from your data


    console.log('info', summary);

    // Calculate unique patient count directly from rides data
    const uniquePatientIds = new Set(ridesData.map(ride => ride.riderInfoId).filter(id => id));
    const uniquePatientCount = uniquePatientIds.size;

    // Keep uniqueMembers from summary for other uses
    const uniqueMembers = {
      totalMembers: summary?.memberServedCount,
      uniqueCount: summary?.uniquePatientCount,
    };

    // Calculate monthly trends for different patient types
    const monthlyPatientTrends = getMonthlyPatientTrends(ridesData);
    const monthlyPatientTrendsData = Object.values(monthlyPatientTrends).sort((a, b) =>
      dayjs(a.month, 'MMM YYYY').diff(dayjs(b.month, 'MMM YYYY')))





    const cancellationData = processCancellationData(ridesData);

    // Cost Center by Distance Distribution (Urban/Suburban/Rural)
    const costCenterByDistance = ridesData.reduce((acc, ride) => {
      let costCenter = ride.costCenter ? ride.costCenter.trim() : '';

      // If cost center is empty or not assigned, use organization name
      if (!costCenter) {
        const org = healthOrganizations.find(o => o.id === ride.healthOrganizationId);
        costCenter = org ? org.name : 'Not Assigned';
      }

      if (!acc[costCenter]) {
        acc[costCenter] = {
          costCenter,
          urban: 0,
          subUrban: 0,
          rural: 0,
          total: 0
        };
      }

      const mileage = parseFloat(ride.actMileage || ride.estMileage || 0);
      if (mileage <= 50) {
        acc[costCenter].urban++;
      } else if (mileage <= 75) {
        acc[costCenter].subUrban++;
      } else {
        acc[costCenter].rural++;
      }
      acc[costCenter].total++;

      return acc;
    }, {});

    // Cost Center by County Matrix
    const costCenterByCounty = ridesData.reduce((acc, ride) => {
      let costCenter = ride.costCenter ? ride.costCenter.trim() : '';

      // If cost center is empty or not assigned, use organization name
      if (!costCenter) {
        const org = healthOrganizations.find(o => o.id === ride.healthOrganizationId);
        costCenter = org ? org.name : 'Not Assigned';
      }

      const county = ride.pickupAddressDetails?.county?.trim() || 'Unknown';

      const key = `${costCenter}|||${county}`;
      acc[key] = (acc[key] || 0) + 1;

      return acc;
    }, {});

    // Transform to array format for easier charting
    const costCenterCountyMatrix = Object.entries(costCenterByCounty).map(([key, count]) => {
      const [costCenter, county] = key.split('|||');
      return { costCenter, county, count };
    });

    // Cost Center Service Coverage Map - Pickup/Dropoff locations by cost center
    const costCenterLocations = ridesData.reduce((acc, ride) => {
      let costCenter = ride.costCenter ? ride.costCenter.trim() : '';

      // If cost center is empty or not assigned, use organization name
      if (!costCenter) {
        const org = healthOrganizations.find(o => o.id === ride.healthOrganizationId);
        costCenter = org ? org.name : 'Not Assigned';
      }

      if (!acc[costCenter]) {
        acc[costCenter] = {
          costCenter,
          pickupLocations: [],
          dropoffLocations: [],
          rides: []
        };
      }

      // Add pickup location if coordinates exist (check both direct and nested coordinates)
      const pickupLat = ride.pickupAddressDetails?.coordinates?.lat || ride.pickupAddressDetails?.lat;
      const pickupLng = ride.pickupAddressDetails?.coordinates?.lng || ride.pickupAddressDetails?.lng;

      if (pickupLat && pickupLng) {
        acc[costCenter].pickupLocations.push({
          lat: pickupLat,
          lng: pickupLng,
          address: ride.pickupAddressDetails.formattedAddress,
          county: ride.pickupAddressDetails.county,
          rideId: ride.seqId
        });
      }

      // Add dropoff location if coordinates exist (check both direct and nested coordinates)
      const dropoffLat = ride.destinationAddressDetails?.coordinates?.lat ||
        ride.destinationAddressDetails?.lat ||
        ride.destinationAddress?.coordinates?.lat ||
        ride.destinationAddress?.lat;
      const dropoffLng = ride.destinationAddressDetails?.coordinates?.lng ||
        ride.destinationAddressDetails?.lng ||
        ride.destinationAddress?.coordinates?.lng ||
        ride.destinationAddress?.lng;

      if (dropoffLat && dropoffLng) {
        acc[costCenter].dropoffLocations.push({
          lat: dropoffLat,
          lng: dropoffLng,
          address: ride.destinationAddressDetails?.formattedAddress || ride.destinationAddress?.formattedAddress,
          county: ride.destinationAddressDetails?.county || ride.destinationAddress?.county,
          rideId: ride.seqId
        });
      }

      acc[costCenter].rides.push(ride);

      return acc;
    }, {});

    // Top Routes by Cost Center - Pickup County → Dropoff County
    const costCenterRoutes = ridesData.reduce((acc, ride) => {
      let costCenter = ride.costCenter ? ride.costCenter.trim() : '';

      // If cost center is empty or not assigned, use organization name
      if (!costCenter) {
        const org = healthOrganizations.find(o => o.id === ride.healthOrganizationId);
        costCenter = org ? org.name : 'Not Assigned';
      }

      const pickupCounty = ride.pickupAddressDetails?.county?.trim() || 'Unknown';
      const dropoffCounty = ride.destinationAddressDetails?.county?.trim() || 'Unknown';

      const routeKey = `${pickupCounty} → ${dropoffCounty}`;
      const key = `${costCenter}|||${routeKey}`;

      if (!acc[key]) {
        acc[key] = {
          costCenter,
          pickupCounty,
          dropoffCounty,
          route: routeKey,
          count: 0
        };
      }
      acc[key].count++;

      return acc;
    }, {});

    // Group routes by cost center and get top routes
    const costCenterTopRoutes = {};
    Object.values(costCenterRoutes).forEach(route => {
      if (!costCenterTopRoutes[route.costCenter]) {
        costCenterTopRoutes[route.costCenter] = [];
      }
      costCenterTopRoutes[route.costCenter].push(route);
    });

    // Sort routes by count and get top 10 for each cost center
    Object.keys(costCenterTopRoutes).forEach(costCenter => {
      costCenterTopRoutes[costCenter].sort((a, b) => b.count - a.count);
      costCenterTopRoutes[costCenter] = costCenterTopRoutes[costCenter].slice(0, 10);
    });

    // Cost Center Activity Timeline - Rides by hour of day
    const costCenterActivityTimeline = ridesData.reduce((acc, ride) => {
      let costCenter = ride.costCenter ? ride.costCenter.trim() : '';

      // If cost center is empty or not assigned, use organization name
      if (!costCenter) {
        const org = healthOrganizations.find(o => o.id === ride.healthOrganizationId);
        costCenter = org ? org.name : 'Not Assigned';
      }

      const hour = dayjs(ride.pickUpDate).hour();

      if (!acc[costCenter]) {
        acc[costCenter] = {
          costCenter,
          hourly: Array(24).fill(0).map((_, i) => ({ hour: i, count: 0 })),
          total: 0
        };
      }

      acc[costCenter].hourly[hour].count++;
      acc[costCenter].total++;

      return acc;
    }, {});

    // Cost Center Cancellation and Completion by Location (County)
    const costCenterLocationPerformance = ridesData.reduce((acc, ride) => {
      let costCenter = ride.costCenter ? ride.costCenter.trim() : '';

      // If cost center is empty or not assigned, use organization name
      if (!costCenter) {
        const org = healthOrganizations.find(o => o.id === ride.healthOrganizationId);
        costCenter = org ? org.name : 'Not Assigned';
      }

      const county = ride.pickupAddressDetails?.county?.trim() || 'Unknown';
      const key = `${costCenter}|||${county}`;

      if (!acc[key]) {
        acc[key] = {
          costCenter,
          county,
          completed: 0,
          canceled: 0,
          expired: 0,
          total: 0,
          completionRate: 0,
          cancellationRate: 0
        };
      }

      acc[key].total++;

      if (ride.status === RIDE_STATUSES.COMPLETED) {
        acc[key].completed++;
      } else if (ride.status === RIDE_STATUSES.CANCELED) {
        acc[key].canceled++;
      } else if (ride.status === RIDE_STATUSES.EXPIRED) {
        acc[key].expired++;
      }

      return acc;
    }, {});

    // Calculate rates and transform to array
    const costCenterLocationPerformanceArray = Object.values(costCenterLocationPerformance).map(item => {
      item.completionRate = item.total > 0 ? ((item.completed / item.total) * 100).toFixed(1) : 0;
      item.cancellationRate = item.total > 0 ? (((item.canceled + item.expired) / item.total) * 100).toFixed(1) : 0;
      return item;
    });

    // Group by cost center for easier rendering
    const costCenterLocationPerformanceGrouped = {};
    costCenterLocationPerformanceArray.forEach(item => {
      if (!costCenterLocationPerformanceGrouped[item.costCenter]) {
        costCenterLocationPerformanceGrouped[item.costCenter] = [];
      }
      costCenterLocationPerformanceGrouped[item.costCenter].push(item);
    });

    // Sort each cost center's data by total rides
    Object.keys(costCenterLocationPerformanceGrouped).forEach(costCenter => {
      costCenterLocationPerformanceGrouped[costCenter].sort((a, b) => b.total - a.total);
    });

    return {
      statusCounts,
      monthlyTrends: monthlyTrendsData,
      orgPerformance: Object.values(orgPerformance),
      transportPerformance: Object.values(transportPerformance),
      driverPerformance: Object.values(driverPerformance),
      counties: counties,
      vehicleTypeCounts,
      costCenterCounts,
      recurrenceAnalysis,
      hoActivityCounts,
      cancellationData,
      noShowsCount,
      noShowRatio,
      uniqueMembers,
      uniquePatientCount,
      satisfactionScore,
      satisfactionResponses,
      rawData: ridesData,
      timeMetrics: timeMetrics,
      monthlyPatientTrends: monthlyPatientTrendsData,
      costCenterByDistance: Object.values(costCenterByDistance),
      costCenterCountyMatrix,
      costCenterLocations: Object.values(costCenterLocations),
      costCenterTopRoutes,
      costCenterActivityTimeline: Object.values(costCenterActivityTimeline),
      costCenterLocationPerformance: costCenterLocationPerformanceGrouped

    };
  }, [ridesData, healthOrganizations, transportCompanies, drivers]);




  function getHOActivityCount(ridesData, property = 'createdBy') {
    const result = {};
    ridesData.forEach(ride => {
      const user = ride[property];
      if (user && user.firstName && user.lastName) {
        const key = `${user.firstName} ${user.lastName}`;
        result[key] = (result[key] || 0) + 1;
      }
    });
    return result;
  }


  function getMonthlyPatientTrends(ridesData) {
    return ridesData.reduce((acc, ride) => {
      const month = dayjs(ride.pickUpDate).format('MMM YYYY');
      if (!acc[month]) {
        acc[month] = {
          month,
          allPatients: 0,
          specialAccommodations: 0,
          riderNoShow: 0,
          frequentScheduled: 0,
          urban: 0,
          subUrban: 0,
          rural: 0
        };
      }

      acc[month].allPatients++;

      if (ride.riderInfo?.specialAccommodations) {
        acc[month].specialAccommodations++;
      }

      // if (ride.riderInfo?.specialAccommodations) {
      //   acc[month].specialAccommodations++;
      // }


      if (ride.riderInfo?.frequentFlyer) {
        acc[month].frequentScheduled++;
      }

      // Determine frequently scheduled (example: 3+ rides in same month)
      // const riderMonthlyRides = ridesData.filter(r =>
      //   r.riderInfoId === ride.riderInfoId &&
      //   dayjs(r.pickUpDate).format('MMM YYYY') === month
      // ).length;

      // if (riderMonthlyRides >= 3) {
      //   acc[month].frequentScheduled++;
      // }

      const riderNoShow = getRiderNoShowCancellationsByMonth(ridesData, month);
      const rideTypeCounts = getUrbanSuburbanRuralCountsByMonth(ridesData, month);

      acc[month].urban = rideTypeCounts?.urban || 0;
      acc[month].subUrban = rideTypeCounts?.subUrban || 0;
      acc[month].rural = rideTypeCounts?.rural || 0;
      acc[month].riderNoShow = riderNoShow.length;



      return acc;
    }, {});
  }



  function processCancellationData(ridesData) {
    // Filter only canceled rides
    const canceledRides = ridesData.filter(ride =>
      ride.status === 'CANCELED' && ride.cancellationInfo
    );

    // Group by canceledBy and then by cancellationReason
    const cancellationData = d3.rollups(
      canceledRides,
      v => d3.rollups(v, vs => vs.length, d => d.cancellationInfo.cancellationReason),
      d => d.cancellationInfo.canceledBy
    );

    // Convert to format needed for donut charts
    const result = {};
    cancellationData.forEach(([canceledBy, reasons]) => {
      result[canceledBy] = reasons.map(([reason, count]) => ({
        reason,
        count
      }));
    });

    // Ensure all categories exist (even if empty)
    const allCategories = ['HO_ADMIN', 'TC_ADMIN', 'DRIVER', 'RIDER', 'MH_ADMIN'];
    allCategories.forEach(cat => {
      if (!result[cat]) {
        result[cat] = [];
      }
    });

    return result;
  };

  function getUrbanSuburbanRuralCountsByMonth(ridesData, month) {
    const result = {
      urban: 0,
      subUrban: 0,
      rural: 0,
    };

    ridesData.forEach(ride => {
      if (
        ride.status === 'COMPLETED' &&
        dayjs(ride.pickUpDate).format('MMM YYYY') === month
      ) {
        if (ride.actMileage <= 50) {
          result.urban += 1;
        } else if (ride.actMileage <= 75) {
          result.subUrban += 1;
        } else if (ride.actMileage > 75) {
          result.rural += 1;
        }
      }
    });

    return result;
  }

  function getRiderNoShowCancellationsByMonth(ridesData, month) {
    return ridesData.filter(
      r =>
        r?.status === 'CANCELED' &&
        r?.cancellationInfo?.cancellationType === 'riderNoShow' &&
        dayjs(r.pickUpDate).format('MMM YYYY') === month
    );
  }




  // Helper function to calculate average time between two timestamps
  function calculateAverageTime(rides, endField, startField) {
    const validRides = rides.filter(ride => ride[endField] && ride[startField]);
    if (validRides.length === 0) return 'N/A';

    const totalMs = validRides.reduce((sum, ride) => {
      return sum + (new Date(ride[endField]) - new Date(ride[startField]));
    }, 0);

    const avgMs = totalMs / validRides.length;
    return formatDuration(avgMs);
  }

  // Helper function to calculate average wait time
  function calculateAverageWaitTime(rides) {
    const validRides = rides.filter(ride => ride.waitTime);
    if (validRides.length === 0) return 'N/A';

    const totalMinutes = validRides.reduce((sum, ride) => sum + parseInt(ride.waitTime || 0), 0);
    const avgMinutes = totalMinutes / validRides.length;
    return `${Math.round(avgMinutes)} mins`;
  }

  // Helper function to calculate average mileage
  function calculateAverageMileage(rides) {
    const validRides = rides.filter(ride => ride.actMileage);
    if (validRides.length === 0) return 'N/A';

    const totalMiles = validRides.reduce((sum, ride) => sum + parseFloat(ride.actMileage || 0), 0);
    const avgMiles = totalMiles / validRides.length;
    return `${avgMiles.toFixed(1)} miles`;
  }

  // Format duration in milliseconds to human-readable format
  function formatDuration(ms) {
    const seconds = Math.floor(ms / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);

    if (hours > 0) return `${hours} hrs ${minutes % 60} mins`;
    if (minutes > 0) return `${minutes} mins`;
    return `${seconds} secs`;
  }




  const exportExcel = () => {
    if (!processedData) return;

    try {
      const workbook = XLSX.utils.book_new();




      // Raw data sheet
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.json_to_sheet(ridesData),
        'Raw Ride Data'
      );

      // Status counts sheet
      const statusData = Object.entries(processedData?.statusCounts).map(([status, count]) => ({
        Status: status,
        Count: count,
        Percentage: `${((count / ridesData?.length) * 100).toFixed(1)}%`
      }));
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.json_to_sheet(statusData),
        'Status Distribution'
      );

      // Monthly trends sheet
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.json_to_sheet(processedData?.monthlyTrends),
        'Monthly Trends'
      );

      // Organization performance sheet
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.json_to_sheet(processedData?.orgPerformance),
        'Org Performance'
      );

      XLSX.writeFile(workbook, `ride-data-${dayjs().format('YYYY-MM-DD')}.xlsx`);
      message.success('Data exported as Excel');
    } catch (error) {
      message.error('Failed to export Excel');
      console.error('Excel export error:', error);
    }
  };

  const exportDetailedViewToExcel = () => {
    if (!ridesData || ridesData.length === 0) {
      message.warning('No data to export');
      return;
    }

    try {
      // Format the data for export with readable column names
      const formattedData = ridesData.map(ride => ({
        'Ride ID': ride.seqId,
        'Status': ride.status,
        'Pickup Date': dayjs(ride.pickUpDate).format('MMM D, YYYY h:mm A'),
        'Vehicle Type': ride.vehicleType || 'N/A',
        'Organization': healthOrganizations.find(o => o.id === ride.healthOrganizationId)?.name || `Org ${ride.healthOrganizationId}`,
        'Transport Company': transportCompanies.find(t => t.id === ride.transportCompanyId)?.name || `Co. ${ride.transportCompanyId}`,
        'Driver': ride.driverName || 'Unassigned',
        'Pickup Address': ride.pickupAddressDetails?.formattedAddress || 'N/A',
        'Destination': ride.destinationAddressDetails?.formattedAddress || 'N/A',
        'Cost Center': ride.costCenter || 'Not Assigned',
        'Created At': dayjs(ride.createdAt).format('MMM D, YYYY h:mm A'),
        'Is Recurring': ride.isRecurring ? 'Yes' : 'No',
        'Wait Time': ride.waitTime ? `${ride.waitTime} minutes` : 'N/A'
      }));

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(formattedData);

      // Set column widths
      const columnWidths = [
        { wch: 15 }, // Ride ID
        { wch: 15 }, // Status
        { wch: 20 }, // Pickup Date
        { wch: 20 }, // Vehicle Type
        { wch: 25 }, // Organization
        { wch: 25 }, // Transport Company
        { wch: 20 }, // Driver
        { wch: 12 }, // Mileage
        { wch: 40 }, // Pickup Address
        { wch: 40 }, // Destination
        { wch: 20 }, // Cost Center
        { wch: 20 }, // Created At
        { wch: 12 }, // Is Recurring
        { wch: 15 }  // Wait Time
      ];
      worksheet['!cols'] = columnWidths;

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Ride Details');
      XLSX.writeFile(workbook, `ride-details-${dayjs().format('YYYY-MM-DD-HHmmss')}.xlsx`);
      message.success(EXPORT_MESSAGES.RIDES_EXPORTED(ridesData?.length));
    } catch (error) {
      message.error(EXPORT_MESSAGES.EXPORT_FAILED);
      console.error('Excel export error:', error);
    }
  };

  const exportMenuItems = [
    // {
    //   key: 'pdf',
    //   label: 'PDF Report',
    //   icon: <FilePdfOutlined />,
    //   onClick: exportPDF
    // },
    // {
    //   key: 'png',
    //   label: 'PNG Images',
    //   icon: <FileImageOutlined />,
    //   onClick: exportPNG
    // },
    // {
    //   key: 'jpeg',
    //   label: 'JPEG Images',
    //   icon: <FileImageOutlined />,
    //   onClick: exportJPEG
    // },
    // {
    //   key: 'excel',
    //   label: 'Excel Data',
    //   icon: <FileExcelOutlined />,
    //   onClick: exportExcel
    // }
  ];

  // Calculate chart dimensions based on window size
  const getChartDimensions = () => {
    if (windowSize.width < 768) {
      return { width: windowSize.width - 48, height: 300 };
    } else if (windowSize.width < 992) {
      return { width: (windowSize.width - 72) / 2, height: 350 };
    } else {
      return { width: (windowSize.width - 396) / 2, height: 400 };
    }
  };

  const chartDimensions = getChartDimensions();

  // Status optionsa
  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'PENDING', label: 'Pending' },
    { value: 'CANCELED', label: 'Canceled' },
    { value: 'ACCEPTED', label: 'Accepted' },
    { value: 'STARTED', label: 'Started' },
    { value: 'COMPLETED', label: 'Completed' },
    { value: 'EXPIRED', label: 'Expired' },
    { value: 'UNABLE_TO_FULFILL', label: 'Unable to fullfill' }
  ];

  // Vehicle type options (extracted from data)
  const vehicleTypeOptions = useMemo(() => {
    if (!ridesData || ridesData?.length === 0) return [{ value: 'all', label: 'All Types' }];

    const types = new Set();
    ridesData.forEach(ride => {
      if (ride.vehicleType) types.add(ride.vehicleType);
    });

    return [
      { value: 'all', label: 'All Types' },
      ...Array.from(types).map(type => ({
        value: type,
        label: type
      }))
    ];
  }, [ridesData]);

  // Driver options
  const driverOptions = useMemo(() => {
    return [
      { value: 'all', label: 'All Drivers' },
      ...drivers.map(driver => ({
        value: driver.id,
        label: driver.name
      }))
    ];
  }, [drivers]);

  // Show ride details modal
  const showRideDetails = (ride) => {
    setSelectedRide(ride);
    setRideModalVisible(true);
  };

  // if (!processedData) {
  //   return (
  //     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
  //       <Spin size="large" tip="Loading dashboard..." />
  //     </div>
  //   );
  // }

  return (
    <Layout className="dashboard-layout" >
      <Header style={{
        background: '#fff',
        padding: '0 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.09)',
        position: 'sticky',
        top: 0,
        zIndex: 1
      }}>
        <Space>
          <MedhaulInsightsIcon width={24} height={24} fill="var(--ant-primary-color)" />
          <h2 style={{ margin: 0 }}>MedHaul Insights</h2>
        </Space>
        <Space>
          <Tooltip title="Toggle filters">
            <Button
              className={classNames({
                [styles.btn]: true,
                [styles.customBtn]: true,

              })}
              icon={<FiltersIcon width={20} height={20} fill="#fff" stroke="#fff" />}
              onClick={() => setShowFilters(!showFilters)}
              type={showFilters ? 'primary' : 'default'}
            />
          </Tooltip>
          {/* <Button
            className={classNames({
              [styles.btn]: true,
              [styles.customBtn]: true,

            })}
            icon={<ReloadOutlined />}
            onClick={fetchData}
            disabled={!dateRange || dateRange.length !== 2 || !dateRange[0] || !dateRange[1]}
          >
            Refresh
          </Button> */}
          {/* <Dropdown menu={{ items: exportMenuItems }} trigger={['click']}>
            <Button className={classNames({
              [styles.btn]: true,
              [styles.customBtn]: true,

            })} type="primary" icon={<DownloadOutlined />}>
              Export
            </Button>
          </Dropdown> */}
        </Space>
      </Header>

      <Content style={{ margin: '24px' }}>
        {/* Filters */}
        {showFilters && (
          <Card
            style={{ marginBottom: 24 }}
            // loading={loading}
            title={
              <Space>
                <FiltersIcon width={20} height={20} />
                <span>Filters</span>
              </Space>
            }
            extra={
              <Button
                className={classNames({
                  [styles.btn]: true,
                  [styles.customBtn]: true,

                })}
                type="primary"
                onClick={() => setDateRange([])}
                size="small"
                disabled={!dateRange}
              >
                Reset Dates
              </Button>
            }
          >
            <Space size="large" wrap style={{ width: '100%' }}>
              <RangePicker
                value={dateRange}
                onChange={(dates) => {
                  if (dates && dates[0] && dates[1]) {
                    setDateRange(dates);
                  } else if (!dates) {
                    setDateRange(null);
                  }
                }}
                onCalendarChange={(dates) => {
                  // Allow updating when both dates are selected
                  if (dates && dates[0] && dates[1]) {
                    setDateRange(dates);
                  }
                }}
                style={{ width: '100%', maxWidth: 300 }}
                allowClear={false}
                allowEmpty={[true, true]}
              />
              {/* <Button
                onClick={() => setDateRange([])}
                style={{ marginLeft: 8 }}
              >
                Reset Dates
              </Button> */}

              {(userRole === USER_ROLES.ENTERPRISE_ADMIN || !viewComponents) && (

                <Select
                  placeholder="Select Health Organization"
                  style={{ width: 250 }}
                  value={selectedOrg}
                  onChange={setSelectedOrg}
                  suffixIcon={<UserOutlined />}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                >
                  <Option value="all">All Organizations</Option>
                  {healthOrganizations.map(org => (
                    <Option key={org.id} value={org.id}>{org.name}</Option>
                  ))}
                </Select>
              )}

              {userRole === USER_ROLES.SUPER_ADMIN && (
                <Select
                  placeholder="Select Transport Company"
                  style={{ width: 250 }}
                  value={selectedTransport}
                  onChange={setSelectedTransport}
                  suffixIcon={<CarOutlined />}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                >
                  <Option value="all">All Companies</Option>
                  {transportCompanies.map(tc => (
                    <Option key={tc.id} value={tc.id}>{tc.name}</Option>
                  ))}
                </Select>

              )}
              {/* <Select
                placeholder="Select Status"
                style={{ width: 200 }}
                value={selectedStatus}
                onChange={setSelectedStatus}
                options={statusOptions}
              />
              <Select
                placeholder="Select Vehicle Type"
                style={{ width: 200 }}
                value={selectedVehicleType}
                onChange={setSelectedVehicleType}
                options={vehicleTypeOptions}
              />
              <Select
                placeholder="Select Driver"
                style={{ width: 200 }}
                value={selectedDriver}
                onChange={setSelectedDriver}
                options={driverOptions}
                disabled={drivers.length === 0}
              /> */}
            </Space>
          </Card>
        )}


        {/* Key Metrics */}

        {/* Key Metrics */}
        <Row gutter={16} style={{ marginBottom: 24 }}>
          {/* Rides Completed */}
          <Col xs={24} sm={12} md={8} lg={4} style={{ marginBottom: windowSize.width < 768 ? 16 : 0 }}>
            <Card style={{ height: '100%' }}>


              <Statistic
                className={styles.statisticFixed}
                title="Rides Completed"
                value={processedData?.statusCounts?.COMPLETED || 0}
                prefix={<RidesCompletedIcon width={23} height={23} />}
                valueStyle={{
                  color: '#52c41a',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  flexWrap: 'wrap',              // Adds small spacing between icon and value
                }}
              // suffix={
              //   <span className={styles.summaryPercentage}>
              //     {ridesData?.length > 0
              //       ? `${Math.round((processedData.statusCounts.COMPLETED / ridesData.length) * 100)}% completion rate`
              //       : 'No rides data'
              //     }
              //   </span>
              // }
              />



            </Card>
          </Col>

          {/* Rides Canceled */}
          <Col xs={24} sm={12} md={8} lg={4} style={{ marginBottom: windowSize.width < 768 ? 16 : 0 }}>
            <Card style={{ height: '100%' }}>


              <Statistic
                className={styles.statisticFixed}
                title="Rides Canceled"
                value={(processedData?.statusCounts?.Expired || 0) + (processedData?.statusCounts?.CANCELED || 0)}
                prefix={<RideCancelledIcon width={23} height={23} />}
                valueStyle={{
                  color: '#f5222d',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  flexWrap: 'wrap',             // Adds small spacing between icon and value
                }}
              // suffix={
              //   <span className={styles.summaryPercentage}>
              //     {ridesData.length > 0 ?
              //       `${Math.round(((processedData.statusCounts.CANCELED) / ridesData.length) * 100)}% cancellation rate` :
              //       'No rides data'}
              //   </span>
              // }
              />



            </Card>
          </Col>

          {/* Total Members Served */}
          <Col xs={24} sm={12} md={8} lg={4} style={{ marginBottom: windowSize.width < 768 ? 16 : 0 }}>
            <Card style={{ height: '100%' }}>
              <Statistic
                className={styles.statisticFixed}
                title="Total Members Served"
                value={processedData?.uniqueMembers?.totalMembers || 0}
                prefix={<TotalMemberedServeIcon width={23} height={23} />}
                valueStyle={{
                  color: '#1890ff',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  flexWrap: 'wrap',               // Adds small spacing between icon and value
                }}
                suffix={
                  <span className={styles.summaryPercentage}>
                    Across all rides
                  </span>
                }
              />

            </Card>
          </Col>

          {/* Unique Members Served */}
          <Col xs={24} sm={12} md={8} lg={4} style={{ marginBottom: windowSize.width < 900 ? 16 : 0 }}>
            <Card style={{ height: '100%' }}>
              <Statistic
                className={styles.statisticFixed}
                title="Unique Members Served"
                value={processedData?.uniqueMembers?.uniqueCount || 0}
                prefix={<UniqueMemberServedIcon width={23} height={23} />}
                valueStyle={{
                  color: '#722ed1',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  flexWrap: 'wrap',              // Adds small spacing between icon and value
                }}
                suffix={
                  <span className={styles.summaryPercentage}>
                    {processedData?.uniqueMembers?.totalMembers > 0 ? (
                      `${Math.round((processedData?.uniqueMembers.uniqueCount / processedData?.uniqueMembers.totalMembers) * 100)}% of total`
                    ) : 'No member data'}
                  </span>
                }
              />

            </Card>
          </Col>

          {/* Rider No-Shows */}
          <Col xs={24} sm={12} md={8} lg={4} style={{ marginBottom: windowSize.width < 768 ? 16 : 0 }}>
            <Card style={{ height: '100%' }}>
              <Statistic
                className={styles.statisticFixed}
                title="Rider No-Shows"
                value={processedData?.noShowsCount || 0}
                prefix={<RiderNoShowIcon width={23} height={23} />}
                valueStyle={{
                  color: '#faad14',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  flexWrap: 'wrap',              // Adds small spacing between icon and value
                }}
              // suffix={
              //   <span className={styles.summaryPercentage}>
              //     {ridesData.length > 0 ? (
              //       `${processedData?.noShowRatio}% no-show rate`
              //     ) : 'No rides data'}
              //   </span>
              // }

              />

            </Card>
          </Col>

          {/* Member Satisfaction — icon + score in one row, stars on next line */}
          <Col xs={24} sm={12} md={8} lg={4} style={{ marginBottom: windowSize.width < 768 ? 16 : 0 }}>
            <Card style={{ height: '100%' }}>
              <div style={{ fontSize: 14, color: 'rgba(0, 0, 0, 0.45)', marginBottom: 4 }}>Member Satisfaction</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                <MemberSatisfactionIcon width={24} height={24} />
                {selectedOrg === 'all' ? (
                  <span style={{ fontSize: 13, color: '#474747' }}>Select an organization to view score</span>
                ) : (
                  <span style={{ fontSize: 24, fontWeight: 500 }}>
                    {processedData?.satisfactionScore?.toFixed(1) ?? '0.0'}
                    <span style={{ fontSize: 16, color: 'rgba(0, 0, 0, 0.45)', marginLeft: 4 }}>/5</span>
                  </span>
                )}
              </div>
              {selectedOrg !== 'all' && (
                <>
                  <div style={{ marginTop: 8 }}>{renderStarRating(processedData?.satisfactionScore ?? 0)}</div>
                  <div style={{ marginTop: 8, fontSize: 12 }}>
                    Based on {processedData?.satisfactionResponses ?? 0} ratings
                  </div>
                </>
              )}
            </Card>
          </Col>

        </Row>

        {/* Data Summary */}
        <Card style={{ marginBottom: 24, background: '#f0f5ff', borderLeft: '4px solid #1890ff' }}>
          <div style={{ padding: '8px 0' }}>
            <InfoIcon width={30} height={30} style={{ color: '#1890ff', marginRight: 8 }} />
            <span style={{ fontSize: 14, lineHeight: '1.8', color: '#262626' }}>
              {ridesData.length > 0 ? (
                <>
                  During the selected period, <strong>{ridesData.length} rides</strong> were entered into the MedHaul platform, with <strong>{processedData.statusCounts.CANCELED || 0} canceled</strong> by a member of the care team or the rider. A total of <strong>{processedData.statusCounts.COMPLETED || 0} rides were completed</strong>.
                  {processedData?.uniquePatientCount > 0 && (
                    <>
                      {' '}<strong>{processedData.uniquePatientCount} members</strong> were transported within the MedHaul network
                      {processedData?.timeMetrics?.avgMileage && processedData.timeMetrics.avgMileage !== 'N/A' && (
                        <>, with an average trip distance of <strong>{processedData.timeMetrics.avgMileage}</strong></>
                      )}
                      .
                    </>
                  )}
                  {Object.keys(processedData?.hoActivityCounts || {}).length > 0 && (
                    <>
                      {' '}The most active users were{' '}
                      {Object.entries(processedData.hoActivityCounts)
                        .sort(([, a], [, b]) => b - a)
                        .slice(0, 2)
                        .map(([name], idx, arr) => (
                          <React.Fragment key={name}>
                            <strong>{name}</strong>
                            {idx === 0 && arr.length > 1 ? ' and ' : ''}
                          </React.Fragment>
                        ))
                      }, who together accounted for a significant portion of overall activity.
                    </>
                  )}
                  {processedData?.satisfactionScore > 0 && (
                    <>
                      The member satisfaction score is <strong>{processedData.satisfactionScore.toFixed(1)}</strong>.{' '}
                    </>
                  )}

                </>
              ) : (
                'No ride data available for the selected filters. Please adjust your date range or filters to view summary information.'
              )}
            </span>
          </div>
        </Card>

        {/* Main Dashboard Content */}
        <Tabs
          defaultActiveKey="1"
          activeKey={activeTab}
          onChange={setActiveTab}
          destroyInactiveTabPane={false}
          items={[
            {
              key: '1',
              label: (
                <span className={styles.tabLabel}>
                  <OverviewIcon width={17} height={17} />
                  Overview
                </span>
              ),
              children: (
                <React.Suspense fallback={<Spin />}>
                  <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                    <Col xs={24} lg={12}>
                      <Card
                        title="Ride Status"
                        //  loading={loading}
                        extra={
                          <Tooltip title="Ride status distribution across all rides">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >

                        <div style={{ height: chartDimensions.height }}>
                          <StatusPieChart
                            data={Object.entries(processedData?.statusCounts).map(([status, count]) => ({
                              label: statusLabel[status],
                              value: count,
                              color: statusColors[status] || '#d9d9d9'
                            }))}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                            onSegmentClick={(segment) => {
                              //  setSelectedStatus(segment.label);
                              //  setActiveTab('3'); // Switch to performance tab
                            }}
                          />
                        </div>
                      </Card>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Card
                        title="Utilization"
                        //  loading={loading}
                        extra={
                          <Tooltip title="utilization trends over time">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>
                          <MonthlyTrendChart
                            data={processedData?.monthlyTrends}
                            xField="month"
                            yFields={rideStatuses}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                          />
                        </div>
                      </Card>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col xs={24} lg={12}>
                      <Card
                        title="Vehicle Types"
                        //  loading={loading}
                        extra={
                          <Tooltip title="Vehicle types distribution across rides">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>

                          <StatusPieChart
                            data={Object.entries(processedData?.vehicleTypeCounts).map(([status, count]) => ({
                              label: VEHICLE_TYPES_LABEL[status],
                              key: status,
                              value: count,
                              color: vehicleTypesColors[status.trim()] || '#d9d9d9'
                            }))}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                            onSegmentClick={(segment) => {
                              // setSelectedVehicleType(segment.label);
                              //setActiveTab('3'); // Switch to performance tab
                            }}


                          // <VehicleTypeChart 
                          //   data={Object.entries(processedData?.vehicleTypeCounts).map(([type, count]) => ({
                          //     label: type,
                          //     value: count
                          //   }))}
                          //   width={chartDimensions.width}
                          //   height={chartDimensions.height}
                          //   onSegmentClick={(segment) => {
                          //     setSelectedVehicleType(segment.label);
                          //   }}
                          />
                        </div>
                      </Card>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Card
                        title=" User Activity (Health Partners)"
                        //   loading={loading}
                        extra={
                          <Tooltip title="•	Total HO team members who have scheduled rides">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>
                          <div style={{ fontWeight: 500, marginBottom: 8 }}>
                            Total: {processedData?.rawData?.length}
                          </div>
                          <StatusPieChart
                            data={Object.entries(processedData?.hoActivityCounts || {}).map(([label, count]) => ({
                              label: label,
                              key: label,
                              value: count,
                              color: stringToColor[label.trim()] || '#d9d9d9'
                            }))}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                            onSegmentClick={(segment) => {
                              // setSelectedStatus(segment.label);
                              //  setActiveTab('3'); // Switch to performance tab
                            }}
                          />
                        </div>
                      </Card>
                    </Col>
                  </Row>


                </React.Suspense>
              )
            },
            {
              key: '2',
              label: (
                <span className={styles.tabLabel}>
                  <AccessIcon width={17} height={17} />
                  Access
                </span>
              ),
              children: (
                <React.Suspense fallback={<Spin />}>
                  <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                    <Col xs={24} lg={12}>
                      <Card
                        title="Rider Metrics"
                        //  loading={loading}
                        extra={

                          <Tooltip title={
                            <>
                              <div><strong>Mobility Indicators</strong></div>
                              <div>- No shows &gt; 5 within 90 days</div>
                              <div>- Cancellations &gt; 5 within 90 days</div>
                              <div>- Rider Age &gt; 70</div>
                              <div>- Rider Weight &gt; 300 lbs</div>
                            </>
                          }>
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >

                        <div style={{ height: chartDimensions.height }}>

                          {/* <MonthlyTrendChart
                            data={processedData?.monthlyPatientTrends}
                            xField="month"
                            yFields={[{
                              key: 'allPatients', label: 'All Patients', color: '#1890ff'
                            },
                            { key: 'specialAccommodations', label: 'Special Accommodations', color: '#ff4d4f' },

                            ]}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                          /> */}

                          <BarChart
                            data={processedData?.monthlyPatientTrends}
                            xField="month"
                            yFields={[{
                              key: 'allPatients', label: 'All Patients', color: '#1890ff'
                            },
                            { key: 'specialAccommodations', label: 'Mobility Indicators', color: '#ff4d4f' },

                            ]}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                            onBarClick={(data) => {

                            }} />

                        </div>
                      </Card>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Card
                        title="Risk Analysis"
                        //  loading={loading}
                        extra={
                          <Tooltip title="All patients' vs Mobility Indicators vs  Frequent Riders">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>
                          {/* <MonthlyTrendChart
                            data={processedData?.monthlyPatientTrends}
                            xField="month"
                            yFields=
                            {[{
                              key: 'riderNoShow', label: 'Rider No Show', color: '#1890ff'
                            },
                            { key: 'specialAccommodations', label: 'Special Accommodations', color: '#ff4d4f' },

                            { key: 'frequentScheduled', label: ' Frequent Riders', color: '#52c41a' }
                            ]}

                            width={chartDimensions.width}
                            height={chartDimensions.height}
                          /> */}

                          <BarChart
                            data={processedData?.monthlyPatientTrends}
                            xField="month"
                            yFields=
                            {[{
                              key: 'riderNoShow', label: 'Rider No Show', color: '#1890ff'
                            },
                            { key: 'specialAccommodations', label: 'Mobility Indicators', color: '#ff4d4f' },

                            { key: 'frequentScheduled', label: 'Frequent Riders', color: '#52c41a' }
                            ]}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                            onBarClick={(data) => {

                            }} />
                        </div>
                      </Card>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col xs={24} lg={12}>
                      <Card
                        title="Rider Outreach (Rural rides vs Non rural rides)"
                        //  loading={loading}
                        extra={
                          <Tooltip title="Rider Outreach (Rural rides vs Non rural rides)">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>
                          {/* <MonthlyTrendChart
                            data={processedData?.monthlyPatientTrends}
                            xField="month"
                            yFields={rideDistanceCategories}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                          /> */}


                          <BarChart
                            data={processedData?.monthlyPatientTrends}
                            xField="month"
                            yFields={rideDistanceCategories}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                            onBarClick={(data) => {

                            }} />
                        </div>
                      </Card>
                    </Col>
                    <Col xs={24} lg={12}>
                      {/* <Card 
                        title="Time Metrics" 
                     //   loading={loading}
                        extra={
                          <Tooltip title="Response, load, and ride duration metrics">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>
                          <TimeMetricsChart 
                            data={processedData?.timeMetrics}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                          />
                        </div>
                      </Card> */}
                    </Col>
                  </Row>
                </React.Suspense>
              )
            },
            {
              key: '3',
              label: (
                <span className={styles.tabLabel}>
                  <DetailedViewIcon width={17} height={17} />
                  Detailed View
                </span>
              ),
              children: (
                <Card
                  title="Ride Details"
                  //  loading={loading}
                  extra={
                    <Space>
                      <span>
                        Showing {ridesData?.length} rides
                      </span>

                      <Button
                        size="small"
                        onClick={() => {
                          setSelectedStatus('all');
                          setSelectedOrg('all');
                          setSelectedTransport('all');
                          setSelectedVehicleType('all');
                          setSelectedDriver('all');
                        }}
                      >
                        Clear Filters
                      </Button>
                    </Space>
                  }
                >
                  <Table
                    dataSource={ridesData}
                    rowKey="id"
                    scroll={{ x: true }}
                    pagination={{
                      pageSize: 10,
                      showSizeChanger: true,
                      pageSizeOptions: ['10', '25', '50', '100']
                    }}
                    onRow={(record) => ({
                      onClick: () => showRideDetails(record)
                    })}
                    columns={[
                      {
                        title: 'Ride ID',
                        dataIndex: 'seqId',
                        key: 'seqId',
                        sorter: (a, b) => a.seqId.localeCompare(b.seqId),
                        fixed: 'left'
                      },
                      {
                        title: 'Status',
                        dataIndex: 'status',
                        key: 'status',
                        filters: statusOptions.filter(opt => opt.value !== 'all').map(opt => ({ text: opt.label, value: opt.value })),
                        onFilter: (value, record) => record.status === value,
                        sorter: (a, b) => a.status.localeCompare(b.status),
                        render: status => (
                          <Badge
                            color={statusColors[status] || '#d9d9d9'}
                            text={status}
                          />
                        )
                      },
                      {
                        title: 'Pickup Date',
                        dataIndex: 'pickUpDate',
                        key: 'pickUpDate',
                        render: date => dayjs(date).format('MMM D, YYYY h:mm A'),
                        sorter: (a, b) => new Date(a.pickUpDate) - new Date(b.pickUpDate)
                      },
                      {
                        title: 'Vehicle Type',
                        dataIndex: 'vehicleType',
                        key: 'vehicleType',
                        filters: vehicleTypeOptions.filter(opt => opt.value !== 'all').map(opt => ({ text: opt.label, value: opt.value })),
                        onFilter: (value, record) => record.vehicleType === value,
                        render: vehicleType => VEHICLE_TYPES_LABEL[vehicleType] || vehicleType || 'N/A'
                      },
                      {
                        title: 'Organization',
                        dataIndex: 'healthOrganizationId',
                        key: 'healthOrganizationId',
                        render: id => healthOrganizations.find(o => o.id === id)?.name || `Org ${id}`
                      },
                      {
                        title: 'Transport Co.',
                        dataIndex: 'transportCompanyId',
                        key: 'transportCompanyId',
                        render: id => transportCompanies.find(t => t.id === id)?.name || `Co. ${id}`
                      },
                      {
                        title: 'Driver',
                        dataIndex: 'driverName',
                        key: 'driverName',
                      },
                      {
                        title: 'Mileage',
                        dataIndex: 'actMileage',
                        key: 'actMileage',
                        render: mileage => mileage ? `${mileage} miles` : 'N/A'
                      },
                      {
                        title: 'Actions',
                        key: 'actions',
                        fixed: 'right',
                        render: (_, record) => (
                          <Button
                            type="link"
                            onClick={(e) => {
                              e.stopPropagation();
                              showRideDetails(record);
                            }}
                          >
                            Details
                          </Button>
                        )
                      }
                    ]}
                  />
                  <Button
                    className={classNames({
                      [styles.btn]: true,
                      [styles.customBtn]: true,
                    })}
                    type="primary"

                    onClick={exportDetailedViewToExcel}
                    disabled={!ridesData || ridesData.length === 0}
                  >
                    Export Report
                  </Button>
                </Card>
              )
            },
            {
              key: '4',
              disabled: viewComponents,
              label: (
                <span className={styles.tabLabel}>
                  <TcPerformanceIcon width={21} height={21} />
                  TC Performance
                </span>
              ),
              children: (
                <React.Suspense fallback={<Spin />}>
                  <Row gutter={[16, 16]}>
                    {/* <Col xs={24}>
                      <Card 
                        title="Organization Performance" 
                       // loading={loading}
                        extra={
                          <Tooltip title="Click on bars to filter by organization">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height+100 }}>
                          <BarChart 
                            data={processedData?.orgPerformance}
                            xField="org"
                            yFields={['COMPLETED', 'EXPIRED', 'CANCELED','UNABLE_TO_FULFILL', 'PENDING']}
                            width={chartDimensions.width * (windowSize.width < 992 ? 1 : 1.5)}
                            height={chartDimensions.height}
                            onBarClick={(data) => {
                              const orgId = healthOrganizations.find(o => o.name === data.org)?.id;
                              if (orgId) {
                                setSelectedOrg(orgId);
                                setActiveTab('2'); // Switch to detailed view
                              }
                            }}
                          />
                        </div>
                      </Card>
                    </Col> */}
                    <Col xs={24}>
                      <Card
                        title="Account Activity"
                        // loading={loading}
                        extra={
                          <Tooltip title="Activity by transport company">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height + 100 }}>
                          <BarChart
                            data={processedData?.transportPerformance}
                            xField="company"
                            yFields={TcStatus}
                            width={chartDimensions.width * (windowSize.width < 992 ? 1 : 1.5)}
                            height={chartDimensions.height}
                            onBarClick={(data) => {
                              const tcId = transportCompanies.find(t => t.name === data.company)?.id;
                              if (tcId) {

                              }
                            }}
                          />
                        </div>
                      </Card>
                    </Col>

                    <Col xs={24}>
                      <Card
                        title="Location Map"
                        // loading={loading}
                        extra={
                          <Tooltip title="Location distribution by county based on pickup address">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height + 100 }}>
                          <RidesByCountyChart
                            data={ridesData}
                            width={chartDimensions.width * (windowSize.width < 992 ? 1 : 1.5)}
                          />


                        </div>
                      </Card>
                    </Col>

                    {/* <Col xs={24}>
                      <Card
                        title="Performance"
                        // loading={loading}
                        extra={
                          <Tooltip title="Click on bars to filter by transport company">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height + 100 }}>
                          <BarChart
                            data={processedData?.transportPerformance}
                            xField="company"
                            yFields={['COMPLETED', 'FAILED']}
                            width={chartDimensions.width * (windowSize.width < 992 ? 1 : 1.5)}
                            height={chartDimensions.height}
                            onBarClick={(data) => {
                              const tcId = transportCompanies.find(t => t.name === data.company)?.id;
                              if (tcId) {
                                setSelectedTransport(tcId);
                                setActiveTab('2'); // Switch to detailed view
                              }
                            }}
                          />
                        </div>
                      </Card>
                    </Col> */}

                    {/* <Col xs={24}>
                      <Card
                        title="Driver Performance"
                      //  loading={loading}
                      >
                        <div style={{ height: chartDimensions.height }}>
                          <DriverPerformanceChart
                            data={processedData?.driverPerformance}
                            width={chartDimensions.width * (windowSize.width < 992 ? 1 : 1.5)}
                            height={chartDimensions.height}
                          />
                        </div>
                      </Card>
                    </Col> */}


                  </Row>
                </React.Suspense>
              )
            },
            {
              key: '6',
              disabled: viewComponents,
              label: (
                <span className={styles.tabLabel}>
                  <GeoInsightsIcon width={20} height={20} />
                  Geo Insights
                </span>
              ),
              children: (
                <React.Suspense fallback={<Spin />}>
                  {/* <Row gutter={[16, 16]} style={{ marginTop: 16 }} justify="center">
                    <Col xs={24} lg={24}>



                    
                      <Card
                        title="Cost Center Distribution"
                        extra={
                          <Tooltip title="Ride distribution by cost center">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >



 
                        <div  style={{ height: chartDimensions.height+100 }}>
                          <div style={{ fontWeight: 500, marginBottom: 8 }}>
                            Total Cost Centers: {Object.keys(processedData?.costCenterCounts || {}).length}
                          </div>
                         
                          <StatusPieChart
                            data={Object.entries(processedData?.costCenterCounts || {}).map(([costCenter, count]) => ({
                              label: costCenter,
                              key: costCenter,
                              value: count,
                              color: stringToColor(costCenter)
                            }))}
                            width={chartDimensions.width+100}
                            height={chartDimensions.height+100}
                            onSegmentClick={(segment) => {
                              // Handle cost center selection if needed
                            }}
                          />
 
                          
                        </div>
                      </Card>
                    </Col>
                  </Row> */}
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24}>

                      <Card
                        title="Geographic Insights for HO "
                        //   loading={loading}
                        extra={
                          <Tooltip title="Shows ride distribution by county based on pickup address">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: 520 }}>
                          <RidesByCountyChart
                            data={ridesData}
                            width={chartDimensions.width * (windowSize.width < 992 ? 1 : 1.5)}
                          />
                        </div>
                      </Card>
                    </Col>
                  </Row>

                  {/* Distance Distribution by Cost Center */}
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24}>
                      <Card
                        title="Distance Distribution by Cost Center/Organization"
                        extra={
                          <Tooltip title="Shows urban, suburban, and rural ride distribution for each cost center (uses organization name if cost center is not assigned)">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>
                          <BarChart
                            data={processedData.costCenterByDistance || []}
                            xField="costCenter"
                            yFields={[
                              { key: 'urban', label: 'Urban (≤ 50 miles)', color: '#52c41a' },
                              { key: 'subUrban', label: 'Suburban (51-75 miles)', color: '#1890ff' },
                              { key: 'rural', label: 'Rural (> 75 miles)', color: '#faad14' }
                            ]}
                            width={chartDimensions.width * (windowSize.width < 992 ? 1 : 1.5)}
                            height={chartDimensions.height}
                            onBarClick={(data) => {
                            }}
                          />
                        </div>
                      </Card>
                    </Col>
                  </Row>


                  {/* Cost Center by County Heat Matrix */}
                  {/* <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24}>
                      <Card
                        title="Cost Center/Organization by County Distribution"
                        extra={
                          <Tooltip title="Shows which cost centers serve which counties (uses organization name if cost center is not assigned)">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ minHeight: 400 }}>
                          {processedData.costCenterCountyMatrix && processedData.costCenterCountyMatrix.length > 0 ? (
                            <Table
                              dataSource={(() => {
                                // Group by cost center
                                const grouped = {};
                                processedData.costCenterCountyMatrix.forEach(item => {
                                  if (!grouped[item.costCenter]) {
                                    grouped[item.costCenter] = {
                                      costCenter: item.costCenter,
                                      counties: {},
                                      total: 0
                                    };
                                  }
                                  grouped[item.costCenter].counties[item.county] = item.count;
                                  grouped[item.costCenter].total += item.count;
                                });

                                return Object.values(grouped).sort((a, b) => b.total - a.total);
                              })()}
                              columns={[
                                {
                                  title: 'Cost Center / Organization',
                                  dataIndex: 'costCenter',
                                  key: 'costCenter',
                                  fixed: 'left',
                                  width: 200,
                                  render: (text) => <strong>{text}</strong>
                                },
                                ...Array.from(
                                  new Set(processedData.costCenterCountyMatrix.map(item => item.county))
                                ).sort().map(county => ({
                                  title: county,
                                  dataIndex: ['counties', county],
                                  key: county,
                                  width: 120,
                                  align: 'center',
                                  render: (count) => count ? (
                                    <Badge
                                      count={count}
                                      style={{
                                        backgroundColor: count > 10 ? '#52c41a' : count > 5 ? '#1890ff' : '#faad14'
                                      }}
                                    />
                                  ) : '-'
                                })),
                                {
                                  title: 'Total Rides',
                                  dataIndex: 'total',
                                  key: 'total',
                                  fixed: 'right',
                                  width: 120,
                                  align: 'center',
                                  render: (total) => <strong>{total}</strong>
                                }
                              ]}
                              pagination={{ pageSize: 10 }}
                              scroll={{ x: 'max-content' }}
                              size="small"
                            />
                          ) : (
                            <div style={{ textAlign: 'center', padding: '40px 0', color: '#999' }}>
                              No data available
                            </div>
                          )}
                        </div>
                      </Card>
                    </Col>
                  </Row> */}

                  {/* Top Counties by Cost Center */}
                  {/* <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24}>
                      <Card
                        title="Top 5 Counties per Cost Center/Organization"
                        extra={
                          <Tooltip title="Shows the top 5 counties served by each cost center (uses organization name if cost center is not assigned)">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ minHeight: 300 }}>
                          {processedData.costCenterCountyMatrix && processedData.costCenterCountyMatrix.length > 0 ? (
                            (() => {
                              // Group by cost center and get top 5 counties for each
                              const grouped = {};
                              processedData.costCenterCountyMatrix.forEach(item => {
                                if (!grouped[item.costCenter]) {
                                  grouped[item.costCenter] = [];
                                }
                                grouped[item.costCenter].push({ county: item.county, count: item.count });
                              });

                              return Object.entries(grouped).map(([costCenter, counties]) => {
                                const topCounties = counties
                                  .sort((a, b) => b.count - a.count)
                                  .slice(0, 5);

                                return (
                                  <div key={costCenter} style={{ marginBottom: 24 }}>
                                    <h4 style={{ marginBottom: 12, color: '#1890ff' }}>{costCenter}</h4>
                                    <Row gutter={[8, 8]}>
                                      {topCounties.map((item, index) => (
                                        <Col key={item.county} xs={24} sm={12} md={8} lg={4}>
                                          <Card size="small" style={{ textAlign: 'center' }}>
                                            <div style={{ fontSize: 12, color: '#999' }}>#{index + 1}</div>
                                            <div style={{ fontWeight: 'bold', margin: '8px 0' }}>{item.county}</div>
                                            <div style={{ fontSize: 20, color: '#1890ff' }}>{item.count}</div>
                                            <div style={{ fontSize: 12, color: '#999' }}>rides</div>
                                          </Card>
                                        </Col>
                                      ))}
                                    </Row>
                                  </div>
                                );
                              });
                            })()
                          ) : (
                            <div style={{ textAlign: 'center', padding: '40px 0', color: '#999' }}>
                              No data available
                            </div>
                          )}
                        </div>
                      </Card>
                    </Col>
                  </Row> */}

                  {/* Top Routes by Cost Center */}
                  {/* <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24}>
                      <Card
                        title="Top Routes by Cost Center/Organization"
                        extra={
                          <Tooltip title="Most common pickup-to-dropoff county routes for each cost center (uses organization name if cost center is not assigned)">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ minHeight: 300 }}>
                          {processedData.costCenterTopRoutes && Object.keys(processedData.costCenterTopRoutes).length > 0 ? (
                            Object.entries(processedData.costCenterTopRoutes).map(([costCenter, routes]) => (
                              <div key={costCenter} style={{ marginBottom: 32 }}>
                                <h4 style={{ marginBottom: 16, color: '#1890ff', borderBottom: '2px solid #f0f0f0', paddingBottom: 8 }}>
                                  {costCenter}
                                </h4>
                                <Table
                                  dataSource={routes.map((route, idx) => ({ ...route, key: idx }))}
                                  columns={[
                                    {
                                      title: 'Rank',
                                      dataIndex: 'rank',
                                      key: 'rank',
                                      width: 80,
                                      align: 'center',
                                      render: (_, __, index) => (
                                        <Badge
                                          count={index + 1}
                                          style={{
                                            backgroundColor: index < 3 ? '#52c41a' : '#1890ff'
                                          }}
                                        />
                                      )
                                    },
                                    {
                                      title: 'Pickup County',
                                      dataIndex: 'pickupCounty',
                                      key: 'pickupCounty',
                                      render: (text) => <strong>{text}</strong>
                                    },
                                    {
                                      title: '',
                                      key: 'arrow',
                                      width: 50,
                                      align: 'center',
                                      render: () => <span style={{ fontSize: 18, color: '#1890ff' }}>→</span>
                                    },
                                    {
                                      title: 'Dropoff County',
                                      dataIndex: 'dropoffCounty',
                                      key: 'dropoffCounty',
                                      render: (text) => <strong>{text}</strong>
                                    },
                                    {
                                      title: 'Total Rides',
                                      dataIndex: 'count',
                                      key: 'count',
                                      align: 'center',
                                      sorter: (a, b) => b.count - a.count,
                                      render: (count) => (
                                        <span style={{ fontSize: 16, fontWeight: 'bold', color: '#1890ff' }}>
                                          {count}
                                        </span>
                                      )
                                    },
                                    {
                                      title: 'Route Type',
                                      key: 'routeType',
                                      align: 'center',
                                      render: (_, record) => (
                                        <Badge
                                          status={record.pickupCounty === record.dropoffCounty ? 'success' : 'processing'}
                                          text={record.pickupCounty === record.dropoffCounty ? 'Same County' : 'Cross County'}
                                        />
                                      )
                                    }
                                  ]}
                                  pagination={false}
                                  size="small"
                                />
                              </div>
                            ))
                          ) : (
                            <div style={{ textAlign: 'center', padding: '40px 0', color: '#999' }}>
                              No route data available
                            </div>
                          )}
                        </div>
                      </Card>
                    </Col>
                  </Row> */}

                  {/* Cost Center Activity Timeline */}
                  {/* <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24}>
                      <Card
                        title="Cost Center/Organization Activity Timeline (By Hour of Day)"
                        extra={
                          <Tooltip title="Shows when rides occur throughout the day for each cost center (uses organization name if cost center is not assigned)">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ minHeight: 400 }}>
                          {processedData.costCenterActivityTimeline && processedData.costCenterActivityTimeline.length > 0 ? (
                            processedData.costCenterActivityTimeline.map((costCenterData, idx) => {
                              const maxCount = Math.max(...costCenterData.hourly.map(h => h.count));

                              return (
                                <div key={idx} style={{ marginBottom: 40 }}>
                                  <h4 style={{ marginBottom: 16, color: '#1890ff' }}>
                                    {costCenterData.costCenter}
                                    <span style={{ fontSize: 14, color: '#999', marginLeft: 8 }}>
                                      (Total: {costCenterData.total} rides)
                                    </span>
                                  </h4>

                                   Hour-by-hour grid visualization 
                                  <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(24, 1fr)',
                                    gap: 4,
                                    marginBottom: 8
                                  }}>
                                    {costCenterData.hourly.map((hourData) => {
                                      const intensity = maxCount > 0 ? (hourData.count / maxCount) : 0;
                                      const backgroundColor = hourData.count === 0
                                        ? '#f5f5f5'
                                        : `rgba(24, 144, 255, ${0.2 + intensity * 0.8})`;

                                      return (
                                        <Tooltip
                                          key={hourData.hour}
                                          title={`${hourData.hour}:00 - ${hourData.count} rides`}
                                        >
                                          <div style={{
                                            backgroundColor,
                                            height: 60,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            borderRadius: 4,
                                            cursor: 'pointer',
                                            border: '1px solid #d9d9d9',
                                            transition: 'all 0.3s'
                                          }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.transform = 'scale(1.05)';
                                              e.currentTarget.style.zIndex = '10';
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.transform = 'scale(1)';
                                              e.currentTarget.style.zIndex = '1';
                                            }}
                                          >
                                            <div style={{ fontSize: 10, fontWeight: 'bold' }}>
                                              {hourData.hour}
                                            </div>
                                            <div style={{ fontSize: 12, fontWeight: 'bold', color: '#1890ff' }}>
                                              {hourData.count}
                                            </div>
                                          </div>
                                        </Tooltip>
                                      );
                                    })}
                                  </div>

                                  Time period labels
                                  <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    fontSize: 11,
                                    color: '#999',
                                    paddingTop: 4
                                  }}>
                                    <span>Midnight</span>
                                    <span>6 AM</span>
                                    <span>Noon</span>
                                    <span>6 PM</span>
                                    <span>Midnight</span>
                                  </div>

                                  Peak hours indicator 
                                  <div style={{ marginTop: 12, fontSize: 13 }}>
                                    <strong>Peak Hours: </strong>
                                    {(() => {
                                      const peakHours = costCenterData.hourly
                                        .filter(h => h.count > 0)
                                        .sort((a, b) => b.count - a.count)
                                        .slice(0, 3);

                                      return peakHours.length > 0
                                        ? peakHours.map((h, i) => (
                                          <Badge
                                            key={h.hour}
                                            count={`${h.hour}:00 (${h.count} rides)`}
                                            style={{
                                              backgroundColor: i === 0 ? '#52c41a' : i === 1 ? '#1890ff' : '#faad14',
                                              marginRight: 8
                                            }}
                                          />
                                        ))
                                        : <span style={{ color: '#999' }}>No data</span>;
                                    })()}
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div style={{ textAlign: 'center', padding: '40px 0', color: '#999' }}>
                              No activity timeline data available
                            </div>
                          )}
                        </div>
                      </Card>
                    </Col>
                  </Row> */}

                  {/* Cost Center Service Coverage Map */}
                  {/* <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24}>
                      <Card
                        title="Cost Center/Organization Service Coverage Summary"
                        extra={
                          <Tooltip title="Geographic service coverage by cost center showing pickup and dropoff locations (uses organization name if cost center is not assigned)">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ minHeight: 400 }}>
                          {processedData.costCenterLocations && processedData.costCenterLocations.length > 0 ? (
                            processedData.costCenterLocations.map((costCenterData, idx) => {
                              // Group locations by county for summary
                              const pickupCounties = {};
                              const dropoffCounties = {};

                              costCenterData.pickupLocations.forEach(loc => {
                                const county = loc.county || 'Unknown';
                                pickupCounties[county] = (pickupCounties[county] || 0) + 1;
                              });

                              costCenterData.dropoffLocations.forEach(loc => {
                                const county = loc.county || 'Unknown';
                                dropoffCounties[county] = (dropoffCounties[county] || 0) + 1;
                              });

                              return (
                                <div key={idx} style={{ marginBottom: 32, borderBottom: '1px solid #f0f0f0', paddingBottom: 24 }}>
                                  <h4 style={{ marginBottom: 16, color: '#1890ff' }}>
                                    {costCenterData.costCenter}
                                  </h4>

                                  <Row gutter={[16, 16]}>
                                    <Col xs={24} md={8}>
                                      <Card size="small" style={{ backgroundColor: '#e6f7ff' }}>
                                        <Statistic
                                          title="Total Rides"
                                          value={costCenterData.rides.length}
                                          prefix={<CarOutlined />}
                                          valueStyle={{ color: '#1890ff' }}
                                        />
                                      </Card>
                                    </Col>
                                    <Col xs={24} md={8}>
                                      <Card size="small" style={{ backgroundColor: '#f6ffed' }}>
                                        <Statistic
                                          title="Pickup Locations"
                                          value={costCenterData.pickupLocations.length}
                                          valueStyle={{ color: '#52c41a' }}
                                        />
                                      </Card>
                                    </Col>
                                    <Col xs={24} md={8}>
                                      <Card size="small" style={{ backgroundColor: '#fff7e6' }}>
                                        <Statistic
                                          title="Dropoff Locations"
                                          value={costCenterData.dropoffLocations.length}
                                          valueStyle={{ color: '#faad14' }}
                                        />
                                      </Card>
                                    </Col>
                                  </Row>

                                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                                    <Col xs={24} md={12}>
                                      <h5 style={{ marginBottom: 8 }}>Pickup Counties Coverage</h5>
                                      <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                                        {Object.entries(pickupCounties)
                                          .sort((a, b) => b[1] - a[1])
                                          .map(([county, count]) => (
                                            <div key={county} style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              padding: '4px 8px',
                                              backgroundColor: '#f5f5f5',
                                              marginBottom: 4,
                                              borderRadius: 4
                                            }}>
                                              <span>{county}</span>
                                              <Badge
                                                count={count}
                                                style={{ backgroundColor: '#52c41a' }}
                                              />
                                            </div>
                                          ))}
                                      </div>
                                    </Col>
                                    <Col xs={24} md={12}>
                                      <h5 style={{ marginBottom: 8 }}>Dropoff Counties Coverage</h5>
                                      <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                                        {Object.entries(dropoffCounties)
                                          .sort((a, b) => b[1] - a[1])
                                          .map(([county, count]) => (
                                            <div key={county} style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              padding: '4px 8px',
                                              backgroundColor: '#f5f5f5',
                                              marginBottom: 4,
                                              borderRadius: 4
                                            }}>
                                              <span>{county}</span>
                                              <Badge
                                                count={count}
                                                style={{ backgroundColor: '#faad14' }}
                                              />
                                            </div>
                                          ))}
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              );
                            })
                          ) : (
                            <div style={{ textAlign: 'center', padding: '40px 0', color: '#999' }}>
                              No location data available
                            </div>
                          )}
                        </div>
                      </Card>
                    </Col>
                  </Row> */}

                  {/* Cost Center Cancellation and Completion by Location */}
                  {/* <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24}>
                      <Card
                        title="Cost Center/Organization Performance by Location (County)"
                        extra={
                          <Tooltip title="Shows completion and cancellation rates for each cost center by county (uses organization name if cost center is not assigned)">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ minHeight: 400 }}>
                          {processedData.costCenterLocationPerformance &&
                            Object.keys(processedData.costCenterLocationPerformance).length > 0 ? (
                            Object.entries(processedData.costCenterLocationPerformance).map(([costCenter, locations]) => (
                              <div key={costCenter} style={{ marginBottom: 40, borderBottom: '1px solid #f0f0f0', paddingBottom: 24 }}>
                                <h4 style={{ marginBottom: 16, color: '#1890ff', borderLeft: '4px solid #1890ff', paddingLeft: 12 }}>
                                  {costCenter}
                                </h4>

                                <Table
                                  dataSource={locations.map((loc, idx) => ({ ...loc, key: idx }))}
                                  columns={[
                                    {
                                      title: 'County',
                                      dataIndex: 'county',
                                      key: 'county',
                                      width: 180,
                                      render: (text) => <strong>{text}</strong>,
                                      sorter: (a, b) => a.county.localeCompare(b.county)
                                    },
                                    {
                                      title: 'Total Rides',
                                      dataIndex: 'total',
                                      key: 'total',
                                      align: 'center',
                                      width: 120,
                                      sorter: (a, b) => b.total - a.total,
                                      defaultSortOrder: 'descend',
                                      render: (count) => (
                                        <Badge
                                          count={count}
                                          style={{ backgroundColor: '#1890ff' }}
                                        />
                                      )
                                    },
                                    {
                                      title: 'Completed',
                                      dataIndex: 'completed',
                                      key: 'completed',
                                      align: 'center',
                                      width: 120,
                                      sorter: (a, b) => b.completed - a.completed,
                                      render: (count) => (
                                        <Badge
                                          count={count}
                                          style={{ backgroundColor: '#52c41a' }}
                                        />
                                      )
                                    },
                                    {
                                      title: 'Completion Rate',
                                      dataIndex: 'completionRate',
                                      key: 'completionRate',
                                      align: 'center',
                                      width: 150,
                                      sorter: (a, b) => parseFloat(b.completionRate) - parseFloat(a.completionRate),
                                      render: (rate, record) => (
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                                          <div style={{
                                            width: 100,
                                            height: 20,
                                            backgroundColor: '#f0f0f0',
                                            borderRadius: 10,
                                            overflow: 'hidden'
                                          }}>
                                            <div style={{
                                              width: `${rate}%`,
                                              height: '100%',
                                              backgroundColor: '#52c41a',
                                              transition: 'width 0.3s'
                                            }} />
                                          </div>
                                          <strong style={{ color: '#52c41a', minWidth: 45 }}>{rate}%</strong>
                                        </div>
                                      )
                                    },
                                    {
                                      title: 'Canceled',
                                      dataIndex: 'canceled',
                                      key: 'canceled',
                                      align: 'center',
                                      width: 110,
                                      sorter: (a, b) => b.canceled - a.canceled,
                                      render: (count) => (
                                        <Badge
                                          count={count}
                                          style={{ backgroundColor: '#ff4d4f' }}
                                        />
                                      )
                                    },
                                    {
                                      title: 'Expired',
                                      dataIndex: 'expired',
                                      key: 'expired',
                                      align: 'center',
                                      width: 100,
                                      sorter: (a, b) => b.expired - a.expired,
                                      render: (count) => (
                                        <Badge
                                          count={count}
                                          style={{ backgroundColor: '#faad14' }}
                                        />
                                      )
                                    },
                                    {
                                      title: 'Cancellation Rate',
                                      dataIndex: 'cancellationRate',
                                      key: 'cancellationRate',
                                      align: 'center',
                                      width: 150,
                                      sorter: (a, b) => parseFloat(b.cancellationRate) - parseFloat(a.cancellationRate),
                                      render: (rate, record) => (
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                                          <div style={{
                                            width: 100,
                                            height: 20,
                                            backgroundColor: '#f0f0f0',
                                            borderRadius: 10,
                                            overflow: 'hidden'
                                          }}>
                                            <div style={{
                                              width: `${rate}%`,
                                              height: '100%',
                                              backgroundColor: '#ff4d4f',
                                              transition: 'width 0.3s'
                                            }} />
                                          </div>
                                          <strong style={{ color: '#ff4d4f', minWidth: 45 }}>{rate}%</strong>
                                        </div>
                                      )
                                    }
                                  ]}
                                  pagination={false}
                                  size="small"
                                  summary={(pageData) => {
                                    const totalRides = pageData.reduce((sum, item) => sum + item.total, 0);
                                    const totalCompleted = pageData.reduce((sum, item) => sum + item.completed, 0);
                                    const totalCanceled = pageData.reduce((sum, item) => sum + item.canceled, 0);
                                    const totalExpired = pageData.reduce((sum, item) => sum + item.expired, 0);
                                    const avgCompletionRate = totalRides > 0 ? ((totalCompleted / totalRides) * 100).toFixed(1) : 0;
                                    const avgCancellationRate = totalRides > 0 ? (((totalCanceled + totalExpired) / totalRides) * 100).toFixed(1) : 0;

                                    return (
                                      <Table.Summary fixed>
                                        <Table.Summary.Row style={{ backgroundColor: '#fafafa', fontWeight: 'bold' }}>
                                          <Table.Summary.Cell index={0}>
                                            <strong>Total Summary</strong>
                                          </Table.Summary.Cell>
                                          <Table.Summary.Cell index={1} align="center">
                                            <Badge count={totalRides} style={{ backgroundColor: '#1890ff' }} />
                                          </Table.Summary.Cell>
                                          <Table.Summary.Cell index={2} align="center">
                                            <Badge count={totalCompleted} style={{ backgroundColor: '#52c41a' }} />
                                          </Table.Summary.Cell>
                                          <Table.Summary.Cell index={3} align="center">
                                            <strong style={{ color: '#52c41a' }}>{avgCompletionRate}%</strong>
                                          </Table.Summary.Cell>
                                          <Table.Summary.Cell index={4} align="center">
                                            <Badge count={totalCanceled} style={{ backgroundColor: '#ff4d4f' }} />
                                          </Table.Summary.Cell>
                                          <Table.Summary.Cell index={5} align="center">
                                            <Badge count={totalExpired} style={{ backgroundColor: '#faad14' }} />
                                          </Table.Summary.Cell>
                                          <Table.Summary.Cell index={6} align="center">
                                            <strong style={{ color: '#ff4d4f' }}>{avgCancellationRate}%</strong>
                                          </Table.Summary.Cell>
                                        </Table.Summary.Row>
                                      </Table.Summary>
                                    );
                                  }}
                                />

                                 Visual Summary Cards 
                                <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                                  <Col xs={24} sm={12} md={8}>
                                    <Card size="small" style={{ backgroundColor: '#e6f7ff', textAlign: 'center' }}>
                                      <Statistic
                                        title="Best Performing County"
                                        value={locations.length > 0 ?
                                          locations.reduce((max, loc) =>
                                            parseFloat(loc.completionRate) > parseFloat(max.completionRate) ? loc : max
                                          ).county : 'N/A'
                                        }
                                        valueStyle={{ fontSize: 16, color: '#52c41a' }}
                                        suffix={
                                          locations.length > 0 ?
                                            <span style={{ fontSize: 14, color: '#52c41a' }}>
                                              ({locations.reduce((max, loc) =>
                                                parseFloat(loc.completionRate) > parseFloat(max.completionRate) ? loc : max
                                              ).completionRate}% completion)
                                            </span> : null
                                        }
                                      />
                                    </Card>
                                  </Col>
                                  <Col xs={24} sm={12} md={8}>
                                    <Card size="small" style={{ backgroundColor: '#fff1f0', textAlign: 'center' }}>
                                      <Statistic
                                        title="Highest Cancellation County"
                                        value={locations.length > 0 ?
                                          locations.reduce((max, loc) =>
                                            parseFloat(loc.cancellationRate) > parseFloat(max.cancellationRate) ? loc : max
                                          ).county : 'N/A'
                                        }
                                        valueStyle={{ fontSize: 16, color: '#ff4d4f' }}
                                        suffix={
                                          locations.length > 0 ?
                                            <span style={{ fontSize: 14, color: '#ff4d4f' }}>
                                              ({locations.reduce((max, loc) =>
                                                parseFloat(loc.cancellationRate) > parseFloat(max.cancellationRate) ? loc : max
                                              ).cancellationRate}% cancellation)
                                            </span> : null
                                        }
                                      />
                                    </Card>
                                  </Col>
                                  <Col xs={24} sm={12} md={8}>
                                    <Card size="small" style={{ backgroundColor: '#f6ffed', textAlign: 'center' }}>
                                      <Statistic
                                        title="Most Active County"
                                        value={locations.length > 0 ?
                                          locations.reduce((max, loc) =>
                                            loc.total > max.total ? loc : max
                                          ).county : 'N/A'
                                        }
                                        valueStyle={{ fontSize: 16, color: '#1890ff' }}
                                        suffix={
                                          locations.length > 0 ?
                                            <span style={{ fontSize: 14, color: '#1890ff' }}>
                                              ({locations.reduce((max, loc) =>
                                                loc.total > max.total ? loc : max
                                              ).total} rides)
                                            </span> : null
                                        }
                                      />
                                    </Card>
                                  </Col>
                                </Row>
                              </div>
                            ))
                          ) : (
                            <div style={{ textAlign: 'center', padding: '40px 0', color: '#999' }}>
                              No performance data available
                            </div>
                          )}
                        </div>
                      </Card>
                    </Col>
                  </Row> */}

                </React.Suspense>
              )
            },
            {
              key: '5',
              label: (
                <span className={styles.tabLabel}>
                  <CancellationIcon width={17} height={17} />
                  Cancellations
                </span>
              ),
              children: (
                <React.Suspense fallback={<Spin />}>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>

                    <Col xs={24} lg={12}>
                      <Card
                        title="Cancellation Reasons – Riders"
                        //   loading={loading}
                        extra={
                          <Tooltip title="Cancellation reasons by riders">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: 400 }}>
                          {!processedData?.cancellationData?.RIDER || Object.keys(processedData?.cancellationData?.RIDER || {}).length === 0 ? (
                            <div style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: '100%',
                              color: 'rgba(0, 0, 0, 0.45)',
                              fontSize: '16px'
                            }}>
                              No records found
                            </div>
                          ) : (
                            <DonutChartWithCenterTotal
                              data={Object.entries(processedData?.cancellationData?.RIDER || {}).map(([_, obj]) => ({
                                label: obj.reason,
                                value: obj.count
                              }))}
                              name="Rider Cancellations"
                              width={chartDimensions.width}
                              height={chartDimensions.height}
                              onSegmentClick={(segment) => {
                                //setSelectedVehicleType(segment.label);
                              }}

                            />)}
                        </div>
                      </Card>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Card
                        title="Canceled vs. Rescheduled Rides"
                        //  loading={loading}
                        extra={
                          <Tooltip title="Shows monthly trends of canceled vs rescheduled rides">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>
                          {/* <MonthlyTrendChart
                            data={processedData?.monthlyTrends}
                            xField="month"
                            yFields={rideReschduleCancellation}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                          /> */}

                          <BarChart
                            data={processedData?.monthlyTrends}
                            xField="month"
                            yFields={rideReschduleCancellation}
                            width={chartDimensions.width}
                            height={chartDimensions.height}
                            onBarClick={(data) => {

                            }}
                          />

                        </div>
                      </Card>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Card
                        title="Cancellation Reasons – HO Team"
                        //  loading={loading}
                        extra={
                          <Tooltip title="Cancellation reasons by health organization team">
                            <InfoIcon width={30} height={30} />
                          </Tooltip>
                        }
                      >
                        <div style={{ height: chartDimensions.height }}>
                          {!processedData?.cancellationData?.RIDER || Object.keys(processedData?.cancellationData?.HO_ADMIN || {}).length === 0 ? (
                            <div style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: '100%',
                              color: 'rgba(0, 0, 0, 0.45)',
                              fontSize: '16px'
                            }}>
                              No records found
                            </div>
                          ) : (

                            <DonutChartWithCenterTotal
                              data={Object.entries(processedData?.cancellationData?.HO_ADMIN || {}).map(([_, obj]) => ({
                                label: obj.reason,
                                value: obj.count
                              }))}
                              name="HO Team Cancellations"
                              width={chartDimensions.width}
                              height={chartDimensions.height}
                              onSegmentClick={(segment) => {
                                //setSelectedVehicleType(segment.label);
                              }}

                            />)}

                        </div>
                      </Card>
                    </Col>
                    {userRole === USER_ROLES.SUPER_ADMIN && (
                      <>
                        <Col xs={24} lg={12}>
                          <Card
                            title="Cancellation Reasons – TCs"
                            //  loading={loading}
                            extra={
                              <Tooltip title="Cancellation reasons by transport companies">
                                <InfoIcon width={30} height={30} />
                              </Tooltip>
                            }
                          >
                            <div style={{ height: chartDimensions.height }}>

                              {!processedData?.cancellationData?.TC_ADMIN || Object.keys(processedData?.cancellationData?.TC_ADMIN || {}).length === 0 ? (
                                <div style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  height: '100%',
                                  color: 'rgba(0, 0, 0, 0.45)',
                                  fontSize: '16px'
                                }}>
                                  No records found
                                </div>
                              ) : (
                                <DonutChartWithCenterTotal
                                  data={Object.entries(processedData?.cancellationData?.TC_ADMIN || {}).map(([_, obj]) => ({
                                    label: obj.reason,
                                    value: obj.count
                                  }))}
                                  name='TC Cancellations'
                                  width={chartDimensions.width}
                                  height={chartDimensions.height}
                                  onSegmentClick={(segment) => {
                                    //setSelectedVehicleType(segment.label);
                                  }}

                                />)}

                            </div>
                          </Card>
                        </Col>


                        <Col xs={24} lg={12}>
                          <Card
                            title="Cancellation Reasons – Drivers"
                            //  loading={loading}
                            extra={
                              <Tooltip title="Cancellation reasons by drivers">
                                <InfoIcon width={30} height={30} />
                              </Tooltip>
                            }
                          >
                            <div style={{ height: chartDimensions.height }}>
                              {!processedData?.cancellationData?.DRIVER || Object.keys(processedData?.cancellationData?.DRIVER || {}).length === 0 ? (
                                <div style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  height: '100%',
                                  color: 'rgba(0, 0, 0, 0.45)',
                                  fontSize: '16px'
                                }}>
                                  No records found
                                </div>
                              ) : (

                                <DonutChartWithCenterTotal
                                  data={Object.entries(processedData?.cancellationData?.DRIVER || {}).map(([_, obj]) => ({
                                    label: obj.reason,
                                    value: obj.count
                                  }))}
                                  name="Driver Cancellations"
                                  width={chartDimensions.width}
                                  height={chartDimensions.height}
                                  onSegmentClick={(segment) => {
                                    //setSelectedVehicleType(segment.label);
                                  }}

                                />)}
                            </div>
                          </Card>
                        </Col>
                      </>
                    )}

                  </Row>
                </React.Suspense>
              )
            },
            {
              key: '7',
              label: (
                <span className={styles.tabLabel}>
                  <ReportsIcon width={17} height={17} fill="#fff" fillPath="#E1F4D3" />
                  Reports
                </span>
              ),
              children: (
                <ReportsSection
                  organizations={healthOrganizations}
                  transportCompanies={transportCompanies}
                  dateRange={dateRange}
                  exportReport={exportReport}
                  selHoOrgId={viewComponents ? selectedOrg : null}
                  userRole={userRole}
                // loading={loading}
                />
              )
            }
          ].filter(item => !item.disabled)}
        />

        {/* Ride Details Modal */}
        <Modal
          title={`Ride Details: ${selectedRide?.seqId || ''}`}
          visible={rideModalVisible}
          onCancel={() => setRideModalVisible(false)}
          footer={null}
          width={800}
        >
          {selectedRide && (
            <div>
              <Row gutter={16}>
                <Col span={12}>
                  <Card title="Basic Information" size="small">
                    <p><strong>Status:</strong> <Badge color={statusColors[selectedRide.status]} text={selectedRide.status} /></p>
                    <p><strong>Vehicle Type:</strong> {VEHICLE_TYPES_LABEL[selectedRide.vehicleType] || 'N/A'}</p>
                    <p><strong>Pickup Date:</strong> {dayjs(selectedRide.pickUpDate).format('MMM D, YYYY h:mm A')}</p>
                    <p><strong>Appointment Date:</strong> {selectedRide.appointmentDate ? dayjs(selectedRide.appointmentDate).format('MMM D, YYYY h:mm A') : 'N/A'}</p>
                    <p><strong>Is Recurring:</strong> {selectedRide.isRecurring ? 'Yes' : 'No'}</p>
                    {selectedRide.isRecurring && (
                      <p><strong>Recurrence Index:</strong> {selectedRide.recurrenceIndex}</p>
                    )}
                  </Card>
                </Col>
                <Col span={12}>
                  <Card title="User Information" size="small">
                    <p><strong>Patient:</strong> {selectedRide.riderInfo.firstName} {selectedRide.riderInfo.lastName}</p>

                    <p><strong>Health Organization:</strong> {healthOrganizations.find(o => o.id === selectedRide.healthOrganizationId)?.name || `Org ${selectedRide.healthOrganizationId}`}</p>
                    <p><strong>Transport Company:</strong> {transportCompanies.find(t => t.id === selectedRide.transportCompanyId)?.name || `Co. ${selectedRide.transportCompanyId}`}</p>
                    <p><strong>Driver:</strong> {selectedRide.driverId ? drivers.find(d => d.id === selectedRide.driverId)?.name || `  ${selectedRide.driverName}` : 'Not assigned'}</p>
                    <p><strong>Created By:</strong> User {selectedRide.createdById}</p>
                  </Card>
                </Col>
              </Row>
              <Row gutter={16} style={{ marginTop: 16 }}>
                <Col span={12}>
                  <Card title="Ride Timeline" size="small">
                    <p><strong>Created At:</strong> {dayjs(selectedRide.createdAt).format('MMM D, YYYY h:mm A')}</p>
                    <p><strong>Accepted At:</strong> {selectedRide.acceptanceTime ? dayjs(selectedRide.acceptanceTime).format('MMM D, YYYY h:mm A') : 'N/A'}</p>
                    <p><strong>Actual Pickup:</strong> {selectedRide.actualPickUpDate ? dayjs(selectedRide.actualPickUpDate).format('MMM D, YYYY h:mm A') : 'N/A'}</p>
                    <p><strong>Completed At:</strong> {selectedRide.unloadTime ? dayjs(selectedRide.unloadTime).format('MMM D, YYYY h:mm A') : 'N/A'}</p>
                    {selectedRide.waitTime && (
                      <p><strong>Wait Time:</strong> {selectedRide.waitTime} minutes</p>
                    )}
                  </Card>
                </Col>
                <Col span={12}>
                  <Card title="Additional Information" size="small">
                    <p><strong>Pickup Address:</strong> {selectedRide.pickupAddressDetails?.formattedAddress || 'N/A'}</p>
                    <p><strong>Destination:</strong> {selectedRide.destinationAddressDetails?.formattedAddress || 'N/A'}</p>
                    {selectedRide.flightInfo && (
                      <p><strong>Flight Info:</strong> {selectedRide.flightInfo}</p>
                    )}
                    <p><strong>Mileage:</strong> {selectedRide.actMileage ? `${selectedRide.actMileage} miles` : 'N/A'}</p>
                    {selectedRide.rideNotes && (
                      <p><strong>Notes:</strong> {selectedRide.rideNotes}</p>
                    )}
                  </Card>
                </Col>
              </Row>
            </div>
          )}
        </Modal>
      </Content>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  healthOrganizations: state.healthOrganizations.healthOrganizations,
  transportCompanies: state.transportOrganizations.transportOrganizations,
  drivers: state.transportOrganizations.drivers,
  //loading: state.rides.loading,
  ridesData: state.rides.reportingRides,
  summary: state.rides.reportingSummary,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchAllTransportOrganizations,
      fetchTCDrivers,
      fetchAllHealthOrganizations,
      resetDrivers,
      getReportingRides,
      exportReport,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(MH_Reporting_Dashboard);